function getUrlParameter(param) {
  var pageUrl = window.location.search.substring(1);
  var params = pageUrl.split('&');

  for (var i = 0; i < params.length; i++) {
    var parameterName = params[i].split('=');
    if (parameterName[0] === param) { return parameterName[1]; }
  }
}

var createUrl = function (base, paths, params) {
  if (arguments.length === 0) throw new Error('Base url or path is required.');

  var _url = base;
  var _paths = paths || [];
  var _params = params || {};

  for (key in _paths) {
    if (!!key) {
      var separator = _url.slice(-1) !== "/" ? "/" : "";
      _url += separator + _paths[key]
    }
  }

  for (key in _params) {
    if (!!_params[key]) {
      var separator = _url.indexOf('?') !== -1 ? "&" : "?";
      _url += separator + key + "=" + _params[key];
    }
  }

  return _url
}

// Util
function toMoney(value) {
  var amount = Number(value).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return '$' + amount;
}

function toFloat(value, precision = 2) {
  return parseFloat(value).toFixed(precision);
}

function toNumber(value) {
  return Number(String(value).replace(/[$,]+/g, ""));
}

function serializeObject(form) {
  var _object = {};
  var _array = form.serializeArray();

  $.each(_array, function () {
    if (_object[this.name]) {
      if (!_object[this.name].push && _object[this.name] !== "0") {
        _object[this.name] = [_object[this.name]];
      }
      if (Array.isArray(_object[this.name])) {
        _object[this.name].push(this.value || "");
      } else {
        _object[this.name] = this.value || "";
      }
    } else {
      _object[this.name] = this.value || "";
    }
  });

  return _object
}

function ensureSettled(promise, timeout = 2000) {
  if (!promise || typeof promise.then !== "function") {
    return Promise.resolve();
  }

  const timeoutPromise = new Promise((resolve) => setTimeout(resolve, timeout));
  return Promise.race([promise, timeoutPromise]);
}

jQuery.fn.toggleValidations = function() {
  var element = jQuery(this);

  if (element.rules().length > 0) {
    element.removeValidations();
  } else {
    element.restoreValidations();
  }
};

jQuery.fn.removeValidations = function() {
  var element = jQuery(this);
  element.data("stored_validations", element.rules());
  element.rules("remove");
};

jQuery.fn.restoreValidations = function() {
  var element = jQuery(this);
  var validations = element.data("stored_validations");
  if (validations !== undefined) {
    element.rules("add", validations);
  }
};

$(document).ready(function() {
  $.extend($.validator.messages, {
    required: $.polyglot.t('validations.required'),
    remote: $.polyglot.t('validations.remote'),
    email: $.polyglot.t('validations.email'),
    url: $.polyglot.t('validations.url'),
    date: $.polyglot.t('validations.date'),
    dateISO: $.polyglot.t('validations.dateISO'),
    number: $.polyglot.t('validations.number'),
    digits: $.polyglot.t('validations.digits'),
    creditcard: $.polyglot.t('validations.creditcard'),
    equalTo: $.polyglot.t('validations.equalTo'),
    accept: $.polyglot.t('validations.accept'),
    maxlength: $.validator.format($.polyglot.t('validations.maxlength')),
    minlength: $.validator.format($.polyglot.t('validations.minlength')),
    rangelength: $.validator.format($.polyglot.t('validations.rangelength')),
    range: $.validator.format($.polyglot.t('validations.range')),
    max: $.validator.format($.polyglot.t('validations.max')),
    min: $.validator.format($.polyglot.t('validations.min')),
    cvv: $.validator.format($.polyglot.t('validations.cvv')),
    ccExpiration: $.validator.format($.polyglot.t('validations.ccExpiration'))
  });

  $.validator.addMethod(
    "regex",
    function(value, element, regexp) {
      var mod = "";

      // if regexp starts with a forward slash, remove it and split on the last one
      if (regexp.charAt(0) === "/") {
        var tokens = regexp.split("/");
        tokens.shift();
        mod = tokens.pop();
        regexp = tokens.join("/");
      }

      var re = new RegExp(regexp, mod);
      return this.optional(element) || re.test(value);
    },
    $.polyglot.t('validations.check_input')
  );

  $.validator.addMethod(
    'imageFileExtension',
    function(value, element) {
      if (value === '') {
        return true;
      }
      var acceptableValues = ['jpg', 'jpeg', 'gif', 'pdf', 'png'];
      var splitValue = value.split('.');
      var extension = splitValue[splitValue.length - 1].toLowerCase();

      if (acceptableValues.indexOf(extension) != -1)
        return true;
      else
        return false;
    },
    $.polyglot.t('validations.image_file_extension')
  );

  $.validator.addMethod(
    'maxFileSize',
    function(value, element) {
      if (element.files) {
        if (element.files.length > 0 && element.files[0].size > 10485760)
          return false;
        else
          return true;
      } else {
        return true;
      }
    },
    $.polyglot.t('validations.max_file_size')
  );

  $.validator.addMethod('strictPhone', function(value, element) {
    return $(element).data("valid_phone");
  }, $.polyglot.t('validations.required'));

  $.validator.addMethod(
    'cvv',
    function(value, element, param) {
      var creditCard = $(param.creditCard).val();
      var cards = {
        amex: {
          length: [15],
          prefix: ['34', '37']
        },
        discover: {
          length: [16],
          prefix: ['6011', '622126', '622127', '622128', '622129', '62213',
                   '62214', '62215', '62216', '62217', '62218', '62219',
                   '6222', '6223', '6224', '6225', '6226', '6227', '6228',
                   '62290', '62291', '622920', '622921', '622922', '622923',
                   '622924', '622925', '644', '645', '646', '647', '648',
                   '649', '65']
        },
        mastercard: {
          length: [16],
          prefix: ['51', '52', '53', '54', '55']
        },
        visa: {
          length: [16],
          prefix: ['4']
        }
      };
      var type, i, creditCardType = null;

      if (!/^[0-9]{3,4}$/.test(value)) {
        return false;
      }

      if (creditCard === '') {
        return true;
      }

      for (type in cards) {
        for (i in cards[type].prefix) {
          if (creditCard.substr(0, cards[type].prefix[i].length) === cards[type].prefix[i] && $.inArray(creditCard.length, cards[type].length) !== -1) {
            creditCardType = type;
            break;
          }
        }
      }

      return (creditCardType === null) ? false : (('amex' === creditCardType) ? (value.length === 4) : (value.length === 3));
    },
    $.polyglot.t('validations.cvv')
  );

  $.validator.addMethod(
    "ccExpiration",
    function(value, element, params) {
      var minMonth = new Date().getMonth() + 1;
      var minYear = new Date().getFullYear();
      var formMonth = $(params.formMonth).val();
      var formYear = $(params.formYear).val();
      var month = parseInt(formMonth);
      var year = parseInt(formYear);

      if ((year > minYear) || ((year === minYear) && (month >= minMonth))) {
        return true;
      } else {
        return false;
      }
    },
    $.polyglot.t('validations.ccExpiration')
  );
});

jQuery.fn.exists = function(){return jQuery(this).length>0;}

jQuery.fn.registriaAutocomplete = function(options){
  var cache = {},
  lastXhr;

  var p = $.extend(true, {
    render: function(item){
      return item.label;
    }
  }, options || {});

  var ac_p = $.extend(true, {
    minLength: 3,
    source: function( request, response ) {
      var term = request.term;
      if ( term in cache ) {
        response( cache[ term ] );
        return;
      }

      if (RegExp('msie*').test(navigator.userAgent) && window.XDomainRequest) {
        // Use Microsoft XDR
        var xdr = new XDomainRequest();
        xdr.open("get", p.url + "?" + $.param(request));
        xdr.onload = function() {
          data = jQuery.parseJSON(xdr.responseText);
          cache[ term ] = data;
          response( data );
        };
        xdr.send();
      } else {
        lastXhr = $.getJSON(p.url, request, function( data, status, xhr ) {
          cache[ term ] = data;
          if ( xhr === lastXhr ) {
            response( data );
          }
        });
      }
    }
  }, p.options || {});

  var ac = jQuery(this).autocomplete(ac_p);

  ac.data("autocomplete")._renderItem = function( ul, item ) {
    return $("<li></li>")
    .data("item.autocomplete", item)
    .append(p.render(item))
    .appendTo(ul); // result of render into append
  };

  return ac;
}

$.extend({
  getUrlVars: function(){
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
      hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[decodeURIComponent(hash[0])] = decodeURIComponent(hash[1]);
    }
    return vars;
  },
  getUrlVar: function(name){
    return $.getUrlVars()[name];
  },
  objectSize: function(obj) {
      var size = 0, key;
      for (key in obj) {
          if (obj.hasOwnProperty(key)) size++;
      }
      return size;
  }
});

function setCookie(c_name,value,expiredays,path)
{
    if(path == undefined)
        path = "/";
    var exdate=new Date();
    exdate.setDate(exdate.getDate()+expiredays);
    document.cookie=c_name+ "=" +escape(value)+
    ((expiredays==null) ? "" : ";expires="+exdate.toUTCString())+
    ";path="+path;
}

function getCookie(c_name)
{
    if (document.cookie.length>0)
      {
      c_start=document.cookie.indexOf(c_name + "=");
      if (c_start!=-1)
        {
        c_start=c_start + c_name.length+1;
        c_end=document.cookie.indexOf(";",c_start);
        if (c_end==-1) c_end=document.cookie.length;
        return unescape(document.cookie.substring(c_start,c_end));
        }
      }
    return "";
}

function postwith (to, p) {
  var myForm = $("<form action='" + to + "' method='POST'></form>");

  $.each(p, function(i,element){
	  var element = $(element);
	  if(element.attr('type') == 'radio') {
	    if(element.attr('checked')) {
	      var newElement = element.clone(true);
  		  newElement.val(element.val());
  		  newElement.attr('checked', true);
  		  element.attr('checked', true);
    		newElement.appendTo(myForm);
	    }
    }
    else {
      var newElement = element.clone(true);
		  newElement.val(element.val());
  		newElement.appendTo(myForm);
    }
	});

  myForm.appendTo('body');
  myForm.submit();
  myForm.remove();
}

function post_to_url(path, params, method) {
  method = method || "post"; // Set method to post by default, if not specified.

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    if(params.hasOwnProperty(key)) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);

      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
}

$(function() {
  $("#registria_form input:visible:first").trigger('focus');
  $('#registria_form').validate({
    errorClass: "invalid",
    submitHandler: function(form) {
      $("[type='submit']", form)
        .val("Please Wait...")
        .attr('disabled', 'disabled');
      form.submit();
    },
    highlight: function (element) {
      const $el = $(element);

      if ($el.hasClass('model-drop') && $el.data('select2')) {
        $el.data('select2').$container.addClass('invalid-ui');
      } else {
        $el.addClass('invalid');
      }
    },

    unhighlight: function (element) {
      const $el = $(element);

      if ($el.hasClass('model-drop') && $el.data('select2')) {
        $el.data('select2').$container.removeClass('invalid-ui');
      } else {
        $el.removeClass('invalid');
      }
    },
    errorPlacement: function(error, element) {

      if(element[0].type === "radio" && $(".survey-error").length) {
        error.appendTo($(".survey-error"));
        if ($('label.invalid').length > 0) {
          $('label.invalid').addClass("d-block mb-0 form-err-vis");
        } else {
          $('span.label').addClass("d-block mb-0 form-err-vis");
        }
      } else if (element[0].type === "radio" && $(".shipping-method-error").length) {
        error.appendTo($(".shipping-method-error"));
        if ($('label.invalid').length > 0) {
          $('label.invalid').addClass("d-block mb-0 form-err-vis");
        } else {
          $('span.label').addClass("d-block mb-0 form-err-vis");
        }
      } else if (element.parent()[0]?.className?.split(' ').includes('selectize-input')
        && !element.parent()[0]?.className?.split(' ').includes('input-group')) {
        error.appendTo($(".form-group-selectize .input-group"));
        if ($('label.invalid').length > 0) {
          $('label.invalid').addClass("d-block mb-0 form-err-vis");
        } else {
          $('span.label').addClass("d-block mb-0 form-err-vis");
        }
      } else {
        error.insertAfter(element);
      }
    },
    showErrors: function(errorMap, errorList) {
      if (!$.isEmptyObject(errorMap)) {
        $('#review_errors').removeClass('d-none');
        $(".survey-error").html('');
      } else {
        $(".survey-error").addClass('d-none');
      }
      this.defaultShowErrors();
    }
  });
});

$(window).on("pageshow", function(event) {
  if (event.originalEvent.persisted) {
    window.location.reload();
  }
});

var Registria = Registria || (function() {
  var RegistriaClass = function() {
    this.Cases = {};

    this.Cases.view = function(caseId, settings){
      $.ajax($.extend(true, {
        type: 'POST',
        url: '/services/cases/view',
        data: {case_id: caseId},
        dataType: "json"
      }, settings || {}));
    };

    this.Cases.accept = function(caseId, settings){
      $.ajax($.extend(true, {
        type: 'POST',
        url: '/services/cases/accept',
        data: {case_id: caseId},
        dataType: "json"
      }, settings || {}));
    };

    this.Cases.decline = function(caseId, settings){
      $.ajax($.extend(true, {
        type: 'POST',
        url: '/services/cases/decline',
        data: {case_id: caseId},
        dataType: "json"
      }, settings || {}));
    };

    this.Cases.close = function(caseId, settings){
      $.ajax($.extend(true, {
        type: 'POST',
        url: '/services/cases/close',
        data: {case_id: caseId},
        dataType: "json"
      }, settings || {}));
    };

    this.Cases.comment = function(caseId, comment, settings){
      $.ajax($.extend(true, {
        type: 'POST',
        url: '/services/cases/comment',
        data: {case_id: caseId, comment: comment},
        dataType: "json"
      }, settings || {}));
    };

    this.Locations = {};

    this.Locations.remove = function(locationId, settings){
      $.ajax($.extend(true, {
        type: 'DELETE',
        url: '/services/locations/'+locationId+'/delete',
        dataType: "json"
      }, settings || {}));
    };

    this.Addresses = {};

    this.Addresses.index = function(userId, settings){
      $.ajax($.extend(true, {
        type: 'GET',
        url:'/services/users/'+userId+'/addresses/',
        data: {},
        dataType: "json"
      }, settings || {}));
    };

    this.Addresses.show = function(userId, addressId, settings){
      $.ajax($.extend(true, {
        type: 'GET',
        url:'/services/users/'+userId+'/addresses/'+addressId,
        data: {},
        dataType: "json"
      }, settings || {}));
    };

    this.Addresses.create = function(userId, data, settings){
      $.ajax($.extend(true, {
        type: 'POST',
        url:'/services/users/'+userId+'/addresses/',
        data: data || {},
        dataType: "json"
      }, settings || {}));
    };

    this.Addresses.update = function(userId, addressId, data, settings){
      $.ajax($.extend(true, {
        type: 'PUT',
        url:'/services/users/'+userId+'/addresses/'+addressId,
        data: data || {},
        dataType: "json"
      }, settings || {}));
    };

    this.Addresses.destroy = function(userId, addressId, settings){
      $.ajax($.extend(true, {
        type: 'DELETE',
        url:'/services/users/'+userId+'/addresses/'+addressId,
        data: {},
        dataType: "json"
      }, settings || {}));
    };

    this.PaymentProfiles = {};

    this.PaymentProfiles.index = function(userId, settings){
      $.ajax($.extend(true, {
        type: 'GET',
        url:'/services/users/'+userId+'/payment_profiles/',
        data: {},
        dataType: "json"
      }, settings || {}));
    };

    this.PaymentProfiles.show = function(userId, profileId, settings){
      $.ajax($.extend(true, {
        type: 'GET',
        url:'/services/users/'+userId+'/payment_profiles/'+profileId,
        data: {},
        dataType: "json"
      }, settings || {}));
    };

    this.PaymentProfiles.create = function(userId, paymentData, settings){
      $.ajax($.extend(true, {
        type: 'POST',
        url:'/services/users/'+userId+'/payment_profiles/',
        data: paymentData,
        dataType: "json"
      }, settings || {}));
    };

    this.PaymentProfiles.update = function(userId, profileId, paymentData, settings){
      $.ajax($.extend(true, {
        type: 'PUT',
        url:'/services/users/'+userId+'/payment_profiles/'+profileId,
        data: paymentData,
        dataType: "json"
      }, settings || {}));
    };

    this.PaymentProfiles.destroy = function(userId, profileId, settings){
      $.ajax($.extend(true, {
        type: 'DELETE',
        url:'/services/users/'+userId+'/payment_profiles/'+profileId,
        data: {},
        dataType: "json"
      }, settings || {}));
    };

    this.ShoppingCart = {};

    this.ShoppingCart.show = function(settings){
      $.ajax($.extend(true, {
        type: 'GET',
        url:'/server_side_carts',
        data: {},
        dataType: "json"
      }, settings || {}));
    };

    this.ShoppingCart.empty = function(settings){
      $.ajax($.extend(true, {
        type: 'PUT',
        url:'/server_side_carts/empty_cart',
        data: {},
        dataType: "json"
      }, settings || {}));
    };

    this.ShoppingCart.reset = function(settings){
      $.ajax($.extend(true, {
        type: 'PUT',
        url:'/server_side_carts/reset_cart',
        data: {},
        dataType: "json"
      }, settings || {}));
    };

    this.ShoppingCart.line_remove = function(line_number, settings){
      $.ajax($.extend(true, {
        type: 'PUT',
        url:"/server_side_carts/remove/"+line_number,
        data: {},
        dataType: "json"
      }, settings || {}));
    };

    this.ShoppingCart.line_inc = function(line_number, qty, settings){
      var line_url = "/server_side_carts/increment";
      var actual_settings = settings;

      if (arguments.length >= 3){
        line_url = line_url + "/" + line_number + "/" + qty;
      } else if (arguments.length == 2){
        if (Object.prototype.toString.call(arguments[1]) == "[object Object]"){
          line_url = line_url + "/" + line_number + "/1";
          actual_settings = qty;
        } else {
          line_url = line_url + "/" + line_number + "/" + qty;
        }
      } else {
        line_url = line_url + "/" + line_number + "/1";
      }

      $.ajax($.extend(true, {
        type: 'PUT',
        url: line_url,
        data: {},
        dataType: "json"
      }, actual_settings || {}));
    };

    this.ShoppingCart.line_dec = function(line_number, qty, settings){
      var line_url = "/server_side_carts/decrement";
      var actual_settings = settings;

      if (arguments.length >= 3){
        line_url = line_url + "/" + line_number + "/" + qty;
      } else if (arguments.length == 2){
        if (Object.prototype.toString.call(arguments[1]) == "[object Object]"){
          line_url = line_url + "/" + line_number + "/1";
          actual_settings = qty;
        } else {
          line_url = line_url + "/" + line_number + "/" + qty;
        }
      } else {
        line_url = line_url + "/" + line_number + "/1";
      }

      $.ajax($.extend(true, {
        type: 'PUT',
        url: line_url,
        data: {},
        dataType: "json"
      }, actual_settings || {}));
    };

    this.ShoppingCart.add = function(sku, qty, rgstrn, price_override, settings){
      var add_url = "/server_side_carts/sku/add";
      var actual_settings = settings;
      if (arguments.length > 4){
        add_url = add_url + "/" + rgstrn + "/" + sku + "/" + qty + "/" + price_override;
      } else if (arguments.length == 4){
        if (Object.prototype.toString.call(arguments[3]) == "[object Object]"){
          add_url = add_url + "/" + rgstrn + "/" + sku + "/" + qty;
          actual_settings = price_override;
        } else {
          add_url = add_url + "/" + rgstrn + "/" + sku + "/" + qty + "/" + price_override;
        }
      } else if (arguments.length == 3){
        if (Object.prototype.toString.call(arguments[2]) == "[object Object]"){
          add_url = add_url + "/" + sku + "/" + qty;
          actual_settings = rgstrn;
        } else {
          add_url = add_url + "/" + rgstrn + "/" + sku + "/" + qty;
        }
      } else if (arguments.length == 2){
        if (Object.prototype.toString.call(arguments[1]) == "[object Object]"){
          add_url = add_url + "/" + sku + "/1";
          actual_settings = qty;
        } else {
          add_url = add_url + "/" + sku + "/" + qty;
        }
      } else {
        add_url = add_url + "/" + sku + "/1";
      }

      $.ajax($.extend(true, {
        type: 'PUT',
        url: add_url,
        data: {},
        dataType: "json"
      }, actual_settings || {}));
    };

    this.Dispatch = {};
    this.Dispatch.ShoppingCart = (function(){
      var klass =  function(){
        var listeners = {};
        var cartEvents = ['show', 'add', 'remove', 'increment', 'decrement', 'empty', 'reset'];

        for (var f in cartEvents) {
          var name = cartEvents[f];
          this[name] = Function('handler', "this.addHandler('"+name+"', handler);")
        }

        this.addHandler = function(eventName, handler) {
          listeners[eventName] = listeners[eventName] || [];
          listeners[eventName].push(handler);
        }

        this.trigger = function(eventName) {
          if(listeners[eventName]) {
            for (var f in listeners[eventName]) {
              listeners[eventName][f].apply(this, Array.prototype.slice.call(arguments, 1));
            }
          }
        }
      }

      return new klass();
    }());
  };

  return new RegistriaClass();
}());

RegistriaShoppingCart = (function() {
  var init = function(settings) {
    var _settings = settings || {};

    return $.ajax($.extend(true, {
      type: 'GET',
      url: '/server_side_carts',
      data: {},
      dataType: 'json',
      cache: false
    }, _settings));
  };

  var emptyCart = function(settings) {
    var _settings = settings || {};

    return $.ajax($.extend(true, {
      type: 'PUT',
      url:'/server_side_carts/empty_cart',
      data: {},
      dataType: "json"
    }, _settings));
  }

  var resetCart = function(settings) {
    var _settings = settings || {};

    return $.ajax($.extend(true, {
      type: 'PUT',
      url:'/server_side_carts/reset_cart',
      data: {},
      dataType: "json"
    }, _settings));
  }

  var validateCart = function (settings) {
    var _settings = settings || {};

    return $.ajax($.extend(true, {
      url: '/server_side_carts/validate',
      type: 'PUT',
      dataType: 'json'
    }, _settings))
  }

  var resetPromotions = function(settings) {
    var _settings = settings || {};

    return $.ajax($.extend(true, {
      type: 'PUT',
      url:'/server_side_carts/reset_promotions',
      data: {},
      dataType: "json"
    }, _settings));
  }

  var removeLine = function(lineNumber, settings) {
    if (arguments.length === 0) throw new Error('Line Number is required.');

    var _settings = settings || {};

    return $.ajax($.extend(true, {
      type: 'PUT',
      url:'/server_side_carts/remove/' + lineNumber,
      data: {},
      dataType: "json"
    }, _settings));
  }

  var removeLines = function(skus, settings) {
    if (arguments.length === 0) throw new Error('Skus is required.');

    var _settings = settings || {};

    return $.ajax($.extend(true, {
      type: 'PUT',
      url:'/server_side_carts/skus/remove',
      data: {
        skus: skus
      },
      dataType: "json"
    }, _settings));
  }

  var incrementLine = function(lineNumber, quantity, settings) {
    if (arguments.length === 0) throw new Error('Line Number is required.');

    var _baseUrl = '/server_side_carts/increment';
    var _quantity = quantity || '1';
    var _settings = settings || {};

    var _url = _baseUrl + '/' + lineNumber + '/' + _quantity

    return $.ajax($.extend(true, {
      type: 'PUT',
      url: _url,
      data: {},
      dataType: "json"
    }, _settings));
  }

  var decrementLine = function(lineNumber, quantity, settings) {
    if (arguments.length === 0) throw new Error('Line Number is required.');

    var _baseUrl = '/server_side_carts/decrement';
    var _quantity = quantity || '1';
    var _settings = settings || {};

    var _url = _baseUrl + '/' + lineNumber + '/' + _quantity

    return $.ajax($.extend(true, {
      type: 'PUT',
      url: _url,
      data: {},
      dataType: "json"
    }, _settings));
  }

  var addLine = function (sku, quantity, registration, settings) {
    if (_.isNil(sku)) throw new Error('SKU is required.');
    if (_.isNil(quantity)) throw new Error('Quantity is required.');
    var baseUrl = '/server_side_carts/sku/add';
    var _settings = settings || {};
    var paths = _.compact([registration, sku, quantity]);
    var url = createUrl(baseUrl, paths)
    return $.ajax($.extend(true, {
      type: 'PUT',
      url: url,
      data: {},
      dataType: "json"
    }, _settings));
  }

  var updateLine = function (settings) {
    var baseUrl = '/server_side_carts/sku/add';
    var _settings = settings || {};
    var url = createUrl(baseUrl)
    return $.ajax($.extend(true, {
      type: 'PUT',
      url: url,
      data: {},
      dataType: "json"
    }, _settings));
  }

  var calculateTax = function (settings) {
    var _settings = settings || {};

    return $.ajax($.extend(true, {
      type: 'POST',
      url: '/services/calculate_tax',
      data: {},
      dataType: 'json'
    }, _settings));
  }

  var addMembershipBenefits = function (settings) {
    var _settings = settings || {};

    return $.ajax($.extend(true, {
      type: 'PUT',
      url: '/server_side_carts/add_membership_benefits',
      data: {},
      dataType: "json"
    }, _settings));
  }

  var addOrderPromotion = function (code, settings) {
    if (arguments.length === 0) throw new Error('Code is required.');

    var _settings = settings || {};

    return $.ajax($.extend(true, {
      type: 'PUT',
      url: '/server_side_carts/add_order_promotion/' + code,
      data: {},
      dataType: "json"
    }, _settings));
  }

  var removePromotion = function (settings) {
    var _settings = settings || {};

    return $.ajax($.extend(true, {
      type: 'PUT',
      url: '/server_side_carts/remove_promotion',
      data: {},
      dataType: "json"
    }, _settings));
  }

  var addOrUpdateShippingMethod = function (shipping_id, settings) {
    var _settings = settings || {};

    return $.ajax($.extend(true, {
      url: '/server_side_carts/update_shipping_method/' + shipping_id,
      type: 'PUT',
      dataType: 'json'
    }, _settings))
  }

  var calculateShipping = function(settings) {
    var _settings = settings || {};

    return $.ajax($.extend(true, {
      url: '/server_side_carts/shipping_estimate',
      type: 'POST',
      dataType: 'json'
    }, _settings))
  }

  return {
    init: init,
    show: init,
    emptyCart: emptyCart,
    resetCart: resetCart,
    validateCart: validateCart,
    removeLine: removeLine,
    removeLines: removeLines,
    incrementLine: incrementLine,
    decrementLine: decrementLine,
    addLine: addLine,
    updateLine: updateLine,
    calculateTax: calculateTax,
    resetPromotions: resetPromotions,
    addMembershipBenefits: addMembershipBenefits,
    addOrderPromotion: addOrderPromotion,
    removePromotion: removePromotion,
    addOrUpdateShippingMethod: addOrUpdateShippingMethod,
    calculateShipping: calculateShipping
  };
})();

RegistriaSearch = (function() {
    var search = function(settings) {
        var _settings = settings || {};

        return $.ajax($.extend(true, {
        type: 'GET',
        url: '/precision/products?has_price=true',
        dataType: 'json',
        cache: false
        }, _settings));
    }
    return {
        search: search
      };
})();

// on search results page




/**
 * frautoComplete
 *
 * Turns any text field into an autocomplete
 * field, given a list of options to populate.
 *
 * @param {Element} targetField The field to target
 * @param {Object} settings Settings object (optional)
 *   @key {Element} hiddenField A hidden field to pass a special value
 *   @key {Number} limit Max number of list items to display
 *   @key {Boolean} validate When true, check if input value matches a list item
 *   @key {Boolean} highlight When true, displayed list items will have the match highlighted
 *   @key {String} modelString Template string for product data (ex. "{name} - {sku}")
 *   @key {Array} list List of autocomplete options
 * @return {Object} Methods
 *   @key {Function} updateList Updates the list
 */

'use strict';
(function (document, window) {

  var frautoComplete = function frautoComplete(targetField) {
    var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var _ref$hiddenField = _ref.hiddenField;
    var hiddenField = _ref$hiddenField === undefined ? targetField : _ref$hiddenField;
    var _ref$limit = _ref.limit;
    var limit = _ref$limit === undefined ? 5 : _ref$limit;
    var _ref$validate = _ref.validate;
    var validate = _ref$validate === undefined ? targetField.getAttribute('data-allowfreeinput') ? false : true : _ref$validate;
    var _ref$highlight = _ref.highlight;
    var highlight = _ref$highlight === undefined ? true : _ref$highlight;
    var _ref$modelString = _ref.modelString;
    var modelString = _ref$modelString === undefined ? targetField.getAttribute('data-model-string') || '{sku}' : _ref$modelString;
    var _ref$list = _ref.list;
    var list = _ref$list === undefined ? [] : _ref$list;
    var pinnedItems = _ref.pinnedItems;
    var fuzzyMatchBeginsWith = _ref.fuzzyMatchBeginsWith || false;

    /**
     * This is where we keep track of moving
     * and changing parts.
     */
    var state = {
      targetField: targetField,
      hiddenField: hiddenField,
      pinnedItems: pinnedItems,
      list: list,
      isScrolling: false
    };

    /**
     * === Data Handlers ===
     */

    /**
     * isProduct
     *
     * Determines if a given item is a
     * Registria Platform product.
     *
     * @param {Object} object The object to test
     * @return {Boolen} True if the item is a product
     */
    function isProduct(object) {
      var props = ['product_id', 'product_sku', 'product_name', 'sku', 'product_family'];
      return props.reduce(function (bool, prop) {
        if (bool) return bool;
        return object.hasOwnProperty(prop);
      }, false);
    }

    function isOrganization(object) {
      var props = ['vendor_identifier'];
      return props.reduce(function (bool, prop) {
        if (bool) return bool;
        return object.hasOwnProperty(prop);
      }, false);
    }

    /**
     * parseTemplateString
     *
     * Parses an object with a template.
     * Object keys will be replaced with
     * their values when the keys are included
     * like "{key}" (ex "{sku} - {name}")
     *
     * @param {String} template The template string
     * @param {Object} obj Object to parse
     */
    function parseTemplateString(template, obj) {
      if (!template || typeof template !== 'string') {
        return null;
      }

      var regex = /\{([^\}]*)\}/g;
      var matches = regex.test(template) && template.match(regex);
      if (matches === false) return false;

      return matches.reduce(function (output, match) {
        var pattern = new RegExp(match);
        var key = match.replace(/\{|\}/g, '');
        var value = obj[key];
        return output.replace(pattern, value);
      }, template);
    }

    /**
     * itemTemplate
     *
     * Parses inputted list item into the
     * output format.
     *
     * @param {String|Object} item The item to parse
     * @return {Object} Template object for display
     */
    function itemTemplate(item) {
      var label, value, loc_id, addr_id;

      if (typeof item === 'string') {
        label = item;
        value = label;
      }
      // test if item is a product
      else if (isProduct(item)) {
        label = parseTemplateString(modelString, {
          name: item.product_name || item.label || item.name,
          sku: item.product_sku || item.sku,
          id: item.product_id || item.id,
          product_family: item.product_family || item.family || item.family_name
        });
        value = item.product_id || item.id;
      }
      // item is an organization?
      else if (isOrganization(item)) {
        label = item.doing_business_as;
        value = item.id;
      }
      // test if item is an object
      else if (item.hasOwnProperty('label')) {
        label = item.label;
        value = item.value || label;
        loc_id = item.locationId;
        addr_id = item.address;
      }

      return { label: label, value: value, loc_id: loc_id, addr_id: addr_id };
    }

    /**
     * filterList
     *
     * Filters the list by input and outputs
     * a new list of template objects.
     *
     * @param {String} input Input to filter against
     * @return {Array} List of template objects
     */
    function filterList(input) {
      var filtered = state.list.filter(function (item) {
        var template = itemTemplate(item);
        return fuzzyMatch(input, template.label);
      }).reduce(function (arr, item, i) {
        if (i == undefined) { i = 0; }
        if (i >= limit) return arr;
        arr.push(itemTemplate(item));
        return arr;
      }, []);

      if (state.pinnedItems) {
        state.pinnedItems.forEach(function(item) {
          var template = itemTemplate(item);
          var ix = filtered.map(function(filteredItem) {
            return filteredItem.label;
          }).indexOf(template.label);
          if (ix === -1) {
            filtered.push(template);
          }
        });
      }

      return filtered;
    }

    /**
     * fuzzyMatch
     *
     * Matches some input string against a given
     * standard string. Comparison is done without
     * special characters, white space, and case.
     *
     * @param {String} input The input to test
     * @param {String} comparison Standard to test against
     * @return {Boolean} True if the strings match
     */
    function fuzzyMatch(input, comparison) {
      if (!input || !comparison) return false;
      var regex = /[\'\"\“\”\‘\’\-\[\]\/\{\}\(\)\*\+\?\!\.\,\\\^\$\|\ ]/g;
      var _input = input.replace(regex, '').toUpperCase();
      var _comparison = comparison.replace(regex, '').toUpperCase();
      var _beginsWith = fuzzyMatchBeginsWith ? '^' : '';
      var _search_regex = _beginsWith + _input;
      var search = new RegExp(_search_regex, 'i');
      return search.test(_comparison);
    }

    /**
     * validateInput
     *
     * Checks whether a given input matches
     * an item in the stored list.
     *
     * @param {String} input The input to test
     * @return {Boolean} True if input is in list
     */
    function validateInput(input) {
      if (!input || typeof input !== 'string') return false;
 
      // normalize input
      input = input.replace(/&amp;/gi, '&');
 
      // if input is present in list as is, return true
      if (
        state.list.some(item => {
          if (typeof item === 'string') {
            return item.replace(/&amp;/gi, '&') === input;
          }
 
          return (
            item?.name?.replace(/&amp;/gi, '&') === input
          );
        })
      ) {
        return true;
      }
 
      // otherwise, check if input matches any itemTemplate label
      return state.list.some(function (item) {
        const label =
          itemTemplate(item)?.label?.replace(/&amp;/gi, '&');
 
        return input === label;
      });
    }

    /**
     * === DOM Handlers ===
     */

    /**
     * buildListItem
     *
     * Produces a list item component
     * given some data to populate.
     *
     * @param {Object} item itemTemplate object
     * @return {Element} List item component
     */
    function buildListItem(_ref2) {
      var label = _ref2.label;
      var value = _ref2.value;
      var loc_id = _ref2.loc_id;
      var addr_id = _ref2.addr_id;
      var li = document.createElement('li');
      var str = highlight ? highlightString(label, state.targetField.value) : label;
      li.innerHTML = str;
      li.setAttribute('data-value', value);
      li.setAttribute('data-loc', loc_id);
      li.setAttribute('data-addr', addr_id);
      return li;
    }

    /**
     * buildList
     *
     * Produces a list of list items
     * from the filtered list.
     *
     * @param {Array} filteredList List of items to build
     * @return {Element} List component
     */
    function buildList(filteredList) {
      var ul = document.createElement('ul');
      ul.classList.add('frauto-list');

      filteredList.map(buildListItem).map(function (el) {
        ul.appendChild(el);
      });

      // detect ul scrolls
      var timer = null;
      ul.addEventListener('scroll', function (event) {
        state.isScrolling = true;

        if (timer !== null) clearTimeout(timer);
        timer = setTimeout(function () {
          state.isScrolling = false;
        }, 250);
      });

      if (ul.childElementCount > 1) {
        var isLiSelected, liText, modelVal;
        if (state.targetField.id == "model") {
          for (var i = 0; i < ul.children.length; i++) {
            liText = ul.children[i].innerText;
            modelVal = document.getElementById('model').value;

            if (liText == modelVal) {
              for (var j = 0; j < ul.children.length; j++) {
                ul.children[j].classList.remove('selected');
              }
              ul.children[i].classList.add('selected');
              isLiSelected = 'selected';
            } else if (ul.children[i].firstElementChild != null) {
              if (ul.children[i].firstElementChild.tagName == 'STRONG') {
                // match sku within braces
                var skuVal = '\(' + modelVal + '\)';
                if (liText.includes(skuVal))   {
                  ul.children[i].classList.add('selected');
                  isLiSelected = 'selected';
                }
              }
            }
          }
        }

        if (isLiSelected == undefined || isLiSelected != 'selected') {
          if (ul.firstElementChild) { ul.firstElementChild.classList.add('selected'); }
        }
      } else {
        if (ul.firstElementChild) ul.firstElementChild.classList.add('selected');
      }

      return ul;
    }

    /**
     * highlightString
     *
     * Wraps the matching part of a string
     * in strong tags.
     *
     * @param {String} str Source string
     * @param {String} substr Substring to highlight
     * @return {String} str with substr highlighted
     */
    function highlightString(str, substr) {
      if (!substr) return str;
      var _str = str.toLowerCase();
      var _substr = substr.toLowerCase();
      var regex = new RegExp(substr.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"), 'i');
      // find index of the match
      var index = _str.indexOf(_substr);
      var insert = str.substr(index, substr.length);

      var highlighted = '<strong>' + insert + '</strong>';
      return str.replace(regex, highlighted);
    }

    /**
     * toggleList
     *
     * Toggles visiblity of the DOM list
     *
     * @param {Boolean} bool List will be shown when true, hidden when false
     */
    function toggleList(bool) {
      var frautoList = state.targetField.parentNode.querySelector('.frauto-list');
      var display = frautoList ? frautoList.style.display : null;

      if (frautoList === null) return;

      if (typeof bool === 'boolean') {
        frautoList.style.display = bool === true ? 'block' : 'none';
      } else {
        frautoList.style.display = display === 'none' ? 'block' : 'none';
      }
    }

    /**
     * clearFields
     *
     * Resets the value of both fields.
     */
    function clearFields() {
      state.targetField.value = '';
      state.hiddenField.value = '';
    }

    /**
     * makeSelection
     *
     * Selects a list item.
     *
     * @param {Element} item The list item to select
     */
    function makeSelection(item) {
      if (item != null) {
        var frautoList = state.targetField.parentNode.querySelector('.frauto-list');
        var length = frautoList.children.length;
        var i, prev_id, prev_label;

        // update field values
        state.targetField.value = item.textContent;
        state.hiddenField.value = item.getAttribute('data-value');

        // update list items
        for (i = length - 1; i >= 0; i--) {
          frautoList.children[i].classList.remove('selected');
        }

        item.classList.add('selected');
        if (frautoList.parentElement != null) {
          prev_id = frautoList.parentElement.htmlFor;
          prev_label = frautoList.parentElement.firstElementChild.htmlFor;
          if (prev_id || prev_label) {
            if (prev_id == 'shipping_address1' || prev_label == 'shipping_address1') {
              $(state.targetField).trigger('blur');
            } else if (prev_id == 'billing_address1' || prev_label == 'billing_address1') {
              $(state.targetField).trigger('blur');
            } else if (prev_id == 'address1' || prev_label == 'address1') {
              $(state.targetField).trigger('blur');
            }
          }
        }
      }
    }

    /**
     * showAutocomplete
     *
     * Updates the list based on field input.
     *
     * @param {Boolean} show When true, list should display
     */
    function showAutocomplete(show) {
      var input = state.targetField.value;
      var templates = filterList(input);
      var oldList = state.targetField.parentNode.querySelector('.frauto-list');
      var fieldId = state.targetField.id;

      if ($('#'+fieldId).hasClass('autocomplete-organizations') || $('#'+fieldId).hasClass('autocomplete-installers')) {
        // REG-30704 & REG-30608 fix : blur event to skip creating new list if Option is already selected.
        var current = oldList ? oldList.querySelector('.selected') : "";
        var currentText = current ? current.textContent : "";
        if (input.toLowerCase() == currentText.toLowerCase()) return;
      }

      var newList = buildList(templates);

      // swap out the lists
      if (oldList) oldList.parentNode.removeChild(oldList);
      state.targetField.parentNode.appendChild(newList);

      // hide the list by default
      toggleList(false);
      if (show || input.length) toggleList(true);
    }

    /**
     * cycleOptions
     *
     * Changes the selected list item based
     * on DOM proximity.
     *
     * @param {String} direction Previous or next
     */
    function cycleOptions(direction) {
      var frautoList = state.targetField.parentNode.querySelector('.frauto-list');
      var current = frautoList.querySelector('.selected');
      var prev = current.previousSibling;
      var next = current.nextSibling;
      var first = frautoList.firstElementChild;
      var last = frautoList.lastElementChild;
      var selection = current;

      // make sure list is showing
      toggleList(true);

      if (direction === 'previous') {
        selection = prev ? prev : last;
      } else if (direction === 'next') {
        selection = next ? next : first;
      }

      // scroll to element if necessary
      selection.scrollIntoView();

      makeSelection(selection);
    }

    /**
     * === Event Handlers ===
     */
    (function () {
      var targetContainer = state.targetField.parentNode;
      var clickTest = null;

      // make selection on click
      var clickHandler = function clickHandler(event) {
        // fix for touch screens
        if (state.isScrolling) return false;

        // only select frauto-list li elements
        if (event.target.parentNode.classList.contains('frauto-list') && event.target.nodeName === 'LI') {
          event.preventDefault();
          state.targetField.focus();
          makeSelection(event.target);
          toggleList(false);
        }
        // make selection on strong word click
        else if (event.target.parentNode.parentNode.classList.contains('frauto-list') &&
                 event.target.parentNode.nodeName === 'LI' &&
                 event.target.nodeName === 'STRONG') {
          event.preventDefault();
          state.targetField.focus();
          makeSelection(event.target.parentNode);
          toggleList(false);
        }
      };

      // mousedown for most browsers, touchend for the rest
      targetContainer.addEventListener('mousedown', clickHandler);
      targetContainer.addEventListener('touchend', clickHandler);

      // handle non-input keys
      state.targetField.addEventListener('keypress', function (event) {
        var selection = targetContainer.querySelector('.frauto-list > .selected');

        // make selection on enter
        if (event.keyCode === 13) {
          event.preventDefault();
          makeSelection(selection);
          toggleList(false);
          if (state.targetField.id.indexOf('address1') != -1) {
            $(state.targetField).trigger('blur');
          } else if (state.targetField.id.indexOf('shipping_address1') != -1) {
            $(state.targetField).trigger('blur');
          } else if (state.targetField.id.indexOf('billing_address1') != -1) {
            $(state.targetField).trigger('blur');
          }
          return;
        }

        // recycle list on backspace
        if (event.keyCode === 8) {
          showAutocomplete(true);
        }
      }, {once: true});

      // keyboard controls and text entry
      state.targetField.addEventListener('input', function (event) {
        var key = event.keyCode;

        // hide list for ESC
        if (key === 27) return toggleList(false);

        // hide list for Backspace
        if (key === 8) return toggleList(false);

        // select next item for DownArrow
        if (key === 40) return cycleOptions('next');

        // select previous item for UpArrow
        if (key === 38) return cycleOptions('previous');

        if (($(this).val()) && ($(this).attr('id').indexOf('address1') != -1)) {
          if ($("label[for*='address1']").length > 0) {
            if ($(this).val().length > 5) {
              showAutocomplete(true);
            } else if ($(this).val() && $(this).val().length > 0 && $(this).val().length <= 5) {
              toggleList(false);
            } else {
              showAutocomplete(true);
            }
          }
        } else {
          // otherwise, show the list
          showAutocomplete(true);
        } // End of unless address
      });

      // allow scrolling with click & drag in IE
      targetContainer.addEventListener('mousedown', function (event) {
        if (event.target.nodeName === 'UL') {
          clickTest = event.target.children.length ? event.target : null;
        }
      });

      targetContainer.addEventListener('mouseup', function (event) {
        if (clickTest && event.target.nodeName === 'UL') {
          clickTest = null;
          event.preventDefault();
        }
      });

      // validate input on blur
      state.targetField.addEventListener('blur', function (event) {
        var listItems = targetContainer.querySelectorAll('li');
        var highlighted = targetContainer.querySelectorAll('li:hover, li.selected');
        var defaultHidden = state.hiddenField.getAttribute('data-default');

        // passthru for above listener
        if (clickTest && clickTest.nodeName === 'UL') {
          clickTest = null;
          state.targetField.focus();
          return true;
        }

        if (($(this).attr('id').indexOf('address1') == -1)) {
          // make selection if only on option is left
          if (listItems.length === 1) {
            makeSelection(listItems[0]);
          }
          // select highlighted option when there is input
          if (state.targetField.value && highlighted.length === 1) {
            makeSelection(highlighted[0]);
          }
        }
        // validate the input
        if (validate) {
          if (!validateInput(state.targetField.value)) {
            if (!($("#serial").data("revserialenabled"))) {
              clearFields();
            }
            else if ($("#serial").data("revserialenabled") && !(highlighted.length === 1)) {
              clearFields();
            }
          }
        } else {
          // set default value for hidden field
          if (defaultHidden && !validateInput(state.targetField.value)) {
            state.hiddenField.value = defaultHidden;
          }
        }

        toggleList(false);
      });

      if ($("label[for*='address1']").length > 0) {
        if (state.targetField.value.length > 5) {
          showAutocomplete(true);
        } else {
          toggleList(false);
        }
      }

      // refilter the list and trigger blur on change
      state.targetField.addEventListener('change', function (event) {
        showAutocomplete();
        event.target.blur();
      });

      // clear selected class on hover
      targetContainer.addEventListener('mouseover', function (event) {
        if (event.target.nodeName === 'LI') {
          var selected = targetContainer.querySelector('.selected');
          if (selected) selected.classList.remove('selected');
          event.target.classList.add('selected');
        }
      });

      // keydown event
      targetContainer.addEventListener('keydown', function (event) {
        const input = event.target.closest('input');
        if (!input) return;
      
        const list = input.parentElement.querySelector('.frauto-list');
        if (!list || getComputedStyle(list).display === 'none') return;
      
        const items = Array.from(list.children);
        let selected = list.querySelector('.selected');
      
        function moveSelection(direction) {
          if (!selected) {
            selected = items[0];
            selected.classList.add('selected');
            selected.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            return;
          }
      
          let index = items.indexOf(selected);
          if (direction === 'down') {
            index = (index + 1) % items.length;
          } else if (direction === 'up') {
            index = (index - 1 + items.length) % items.length;
          }
      
          selected.classList.remove('selected');
          selected = items[index];
          selected.classList.add('selected');
      
          // Scroll the selected item into view inside the dropdown
          selected.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      
          // Optional: Ensure the dropdown itself is fully visible on screen
          ensureDropdownVisible(list);
        }
      
        //  Apply selection (Enter or Tab)
        function applySelection() {
          if (selected) {
            makeSelection(selected); // your existing function
            toggleList(false);       // your existing function
          }
        }
      
        // Ensure dropdown fully visible on screen 
        function ensureDropdownVisible(dropdown) {
          const rect = dropdown.getBoundingClientRect();
          if (rect.bottom > window.innerHeight) {
            window.scrollBy({ top: rect.bottom - window.innerHeight + 10, behavior: 'smooth' });
          } else if (rect.top < 0) {
            window.scrollBy({ top: rect.top - 10, behavior: 'smooth' });
          }
        }
      
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            event.stopPropagation();
            moveSelection('down');
            break;
      
          case 'ArrowUp':
            event.preventDefault();
            event.stopPropagation();
            moveSelection('up');
            break;
      
          case 'Enter':
            event.preventDefault();
            applySelection();
            break;
      
          case 'Tab':
            applySelection(); // allow normal tab focus movement
            break;
        }
      });
    })();

    return {
      updateList: function updateList(list) {
        if (!Array.isArray(list)) {
          throw new Error('updateList must be called with an array. Called with: ' + list);
        }
        //if the list is empty then simply dont show any list. Generally happens user has typed <5 chars T13;
        if (list.length == 0) {
          toggleList(false);
          return;
        }
        state.list = list;
        showAutocomplete();

        $(state.targetField).trigger({
          type: "list-updated",
          list: list,
          targetField: state.targetField,
          hiddenField: state.hiddenField,
          toggleList: toggleList
        });
      }
    };
  };

  // export the function
  window.frautoComplete = frautoComplete;
})(document, window);


/*
 * Mailcheck https://github.com/mailcheck/mailcheck
 * Author
 * Derrick Ko (@derrickko)
 *
 * Released under the MIT License.
 *
 * v 1.1.0
 */

var Mailcheck = {
  domainThreshold: 2,
  secondLevelThreshold: 2,
  topLevelThreshold: 2,

  defaultDomains: ['msn.com', 'bellsouth.net',
    'telus.net', 'comcast.net', 'optusnet.com.au',
    'earthlink.net', 'qq.com', 'sky.com', 'icloud.com',
    'mac.com', 'sympatico.ca', 'googlemail.com',
    'att.net', 'xtra.co.nz', 'web.de',
    'cox.net', 'gmail.com', 'ymail.com',
    'aim.com', 'rogers.com', 'verizon.net',
    'rocketmail.com', 'google.com', 'optonline.net',
    'sbcglobal.net', 'aol.com', 'me.com', 'btinternet.com',
    'charter.net', 'shaw.ca'],

  defaultSecondLevelDomains: ["yahoo", "hotmail", "mail", "live", "outlook", "gmx"],

  defaultTopLevelDomains: ["com", "com.au", "com.tw", "ca", "co.nz", "co.uk", "de",
    "fr", "it", "ru", "net", "org", "edu", "gov", "jp", "nl", "kr", "se", "eu",
    "ie", "co.il", "us", "at", "be", "dk", "hk", "es", "gr", "ch", "no", "cz",
    "in", "net", "net.au", "info", "biz", "mil", "co.jp", "sg", "hu"],

  run: function(opts) {
    opts.domains = opts.domains || Mailcheck.defaultDomains;
    opts.secondLevelDomains = opts.secondLevelDomains || Mailcheck.defaultSecondLevelDomains;
    opts.topLevelDomains = opts.topLevelDomains || Mailcheck.defaultTopLevelDomains;
    opts.distanceFunction = opts.distanceFunction || Mailcheck.sift3Distance;

    var defaultCallback = function(result){ return result };
    var suggestedCallback = opts.suggested || defaultCallback;
    var emptyCallback = opts.empty || defaultCallback;

    var result = Mailcheck.suggest(Mailcheck.encodeEmail(opts.email), opts.domains, opts.secondLevelDomains, opts.topLevelDomains, opts.distanceFunction);

    return result ? suggestedCallback(result) : emptyCallback()
  },

  suggest: function(email, domains, secondLevelDomains, topLevelDomains, distanceFunction) {
    email = email.toLowerCase();

    var emailParts = this.splitEmail(email);

    var closestDomain = this.findClosestDomain(emailParts.domain, domains, distanceFunction, this.domainThreshold);

    if (closestDomain) {
      if (closestDomain == emailParts.domain) {
        // The email address exactly matches one of the supplied domains; do not return a suggestion.
        return false
      } else {
        // The email address closely matches one of the supplied domains; return a suggestion
        return { address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain };
      }
    }

    // The email address does not closely match one of the supplied domains
    var closestSecondLevelDomain = this.findClosestDomain(emailParts.secondLevelDomain, secondLevelDomains, distanceFunction, this.secondLevelThreshold);
    var closestTopLevelDomain    = this.findClosestDomain(emailParts.topLevelDomain, topLevelDomains, distanceFunction, this.topLevelThreshold);

    if (emailParts.domain) {
      var closestDomain = emailParts.domain;
      var rtrn = false;

      if(closestSecondLevelDomain && closestSecondLevelDomain != emailParts.secondLevelDomain) {
        // The email address may have a mispelled second-level domain; return a suggestion
        closestDomain = closestDomain.replace(emailParts.secondLevelDomain, closestSecondLevelDomain);
        rtrn = true;
      }

      if(closestTopLevelDomain && closestTopLevelDomain != emailParts.topLevelDomain) {
        // The email address may have a mispelled top-level domain; return a suggestion
        closestDomain = closestDomain.replace(emailParts.topLevelDomain, closestTopLevelDomain);
        rtrn = true;
      }

      if (rtrn == true) {
        return { address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain };
      }
    }

    /* The email address exactly matches one of the supplied domains, does not closely
     * match any domain and does not appear to simply have a mispelled top-level domain,
     * or is an invalid email address; do not return a suggestion.
     */
    return false;
  },

  findClosestDomain: function(domain, domains, distanceFunction, threshold) {
    threshold = threshold || this.topLevelThreshold;
    var dist;
    var minDist = 99;
    var closestDomain = null;

    if (!domain || !domains) {
      return false;
    }
    if(!distanceFunction) {
      distanceFunction = this.sift3Distance;
    }

    for (var i = 0; i < domains.length; i++) {
      if (domain === domains[i]) {
        return domain;
      }
      dist = distanceFunction(domain, domains[i]);
      if (dist < minDist) {
        minDist = dist;
        closestDomain = domains[i];
      }
    }

    if (minDist <= threshold && closestDomain !== null) {
      return closestDomain;
    } else {
      return false;
    }
  },

  sift3Distance: function(s1, s2) {
    // sift3: http://siderite.blogspot.com/2007/04/super-fast-and-accurate-string-distance.html
    if (s1 == null || s1.length === 0) {
      if (s2 == null || s2.length === 0) {
        return 0;
      } else {
        return s2.length;
      }
    }

    if (s2 == null || s2.length === 0) {
      return s1.length;
    }

    var c = 0;
    var offset1 = 0;
    var offset2 = 0;
    var lcs = 0;
    var maxOffset = 5;

    while ((c + offset1 < s1.length) && (c + offset2 < s2.length)) {
      if (s1.charAt(c + offset1) == s2.charAt(c + offset2)) {
        lcs++;
      } else {
        offset1 = 0;
        offset2 = 0;
        for (var i = 0; i < maxOffset; i++) {
          if ((c + i < s1.length) && (s1.charAt(c + i) == s2.charAt(c))) {
            offset1 = i;
            break;
          }
          if ((c + i < s2.length) && (s1.charAt(c) == s2.charAt(c + i))) {
            offset2 = i;
            break;
          }
        }
      }
      c++;
    }
    return (s1.length + s2.length) /2 - lcs;
  },

  splitEmail: function(email) {
    var parts = email.trim().split('@');

    if (parts.length < 2) {
      return false;
    }

    for (var i = 0; i < parts.length; i++) {
      if (parts[i] === '') {
        return false;
      }
    }

    var domain = parts.pop();
    var domainParts = domain.split('.');
    var sld = '';
    var tld = '';

    if (domainParts.length == 0) {
      // The address does not have a top-level domain
      return false;
    } else if (domainParts.length == 1) {
      // The address has only a top-level domain (valid under RFC)
      tld = domainParts[0];
    } else {
      // The address has a domain and a top-level domain
      sld = domainParts[0];
      for (var i = 1; i < domainParts.length; i++) {
        tld += domainParts[i] + '.';
      }
      tld = tld.substring(0, tld.length - 1);
    }

    return {
      topLevelDomain: tld,
      secondLevelDomain: sld,
      domain: domain,
      address: parts.join('@')
    }
  },

  // Encode the email address to prevent XSS but leave in valid
  // characters, following this official spec:
  // http://en.wikipedia.org/wiki/Email_address#Syntax
  encodeEmail: function(email) {
    var result = encodeURI(email);
    result = result.replace('%20', ' ').replace('%25', '%').replace('%5E', '^')
                   .replace('%60', '`').replace('%7B', '{').replace('%7C', '|')
                   .replace('%7D', '}');
    return result;
  }
};

// Export the mailcheck object if we're in a CommonJS env (e.g. Node).
// Modeled off of Underscore.js.
if (typeof module !== 'undefined' && module.exports) {
    module.exports = Mailcheck;
}

// Support AMD style definitions
// Based on jQuery (see http://stackoverflow.com/a/17954882/1322410)
if (typeof define === "function" && define.amd) {
  define("mailcheck", [], function() {
    return Mailcheck;
  });
}

if (typeof window !== 'undefined' && window.jQuery) {
  (function($){
    $.fn.mailcheck = function(opts) {
      var self = this;
      if (opts.suggested) {
        var oldSuggested = opts.suggested;
        opts.suggested = function(result) {
          oldSuggested(self, result);
        };
      }

      if (opts.empty) {
        var oldEmpty = opts.empty;
        opts.empty = function() {
          oldEmpty.call(null, self);
        };
      }

      opts.email = this.val();
      Mailcheck.run(opts);
    }
  })(jQuery);
}


// based on PHP Name Parser by Josh Fraser (joshfraser.com)
// http://www.onlineaspect.com/2009/08/17/splitting-names/
// ported to JavaScript by Mark Pemburn (pemburnia.com)
// released under Apache 2.0 license

var NameParse = (function(){
    function NameParse() {
        return NameParse;
    }

        // split full names into the following parts:
        // - prefix / salutation  (Mr., Mrs., etc)
        // - given name / first name
        // - middle initials
        // - surname / last name
        // - suffix (II, Phd, Jr, etc)
    NameParse.parse = function (fullName) {
        fullName = fullName.trim();

        var
            nameParts = [],
            firstName = "",
            lastName = "",
            initials = "",
            initials = "",
            word = null,
            j = 0,
            i = 0;

        // split into words
        // completely ignore any words in parentheses
        nameParts = fullName.split(" ").filter(function(namePart){
            return (namePart.indexOf("(") === -1);
        });

        var
            numWords = nameParts.length,
            // check for prefix and suffix
            salutation = this.is_salutation(nameParts[0]),
            suffix = this.is_suffix(nameParts[numWords - 1]),
            // trim any found prefixes and suffixes
            start = (salutation) ? 1 : 0,
            end = (suffix) ? numWords - 1 : numWords;

        // update word to start parsing inner
        word = nameParts[start];

        // if we start off with an initial, we'll call it the first name
        if (this.is_initial(word)) {
            // if so, do a look-ahead to see if they go by their middle name
            // for ex: "R. Jason Smith" => "Jason Smith" & "R." is stored as an initial
            // but "R. J. Smith" => "R. Smith" and "J." is stored as an initial
            if (this.is_initial(nameParts[start + 1])) {
                firstName += " " + word.toUpperCase(); }
            else {
                initials += " " + word.toUpperCase(); }
        } else {
            firstName += " " + this.fix_case(word);
        }

        // concat the first name
        for (i=start + 1; i<(end - 1); i++) {
            word = nameParts[i];
            // move on to parsing the last name if we find an indicator of a compound last name (Von, Van, etc)
            // we do not check earlier to allow for rare cases where an indicator is actually the first name (like "Von Fabella")
            if (this.is_compound_lastName(word)) {
                break;
            }

            if (this.is_initial(word)) {
                initials += " " + word.toUpperCase();
            } else {
                firstName += " " + this.fix_case(word);
            }
        }

        // check that we have more than 1 word in our string
        if ((end - start) > 1) {
            // concat the last name
            for (j=i; j<end; j++) {
                lastName += " " + this.fix_case(nameParts[j]);
            }
        }

        // return the various parts in an array
        return {
            "salutation": salutation || "",
            "firstName": firstName.trim(),
            "initials": initials.trim(),
            "lastName": lastName.trim(),
            "suffix": suffix || ""
        };
    };

    NameParse.removeIgnoredChars = function (word) {
        //ignore periods
        //return word.replace(".","");
      if(word) {
        return word.replace(/\./g,'');
      }
    };

    // detect and format standard salutations
    // I'm only considering english honorifics for now & not words like
    NameParse.is_salutation = function (word) {
      if(word) {
        word = this.removeIgnoredChars(word).toLowerCase();
        // returns normalized values
        switch (word) {
            case 'mr':
            case 'master':
            case 'mister':
                return "Mr.";
            case 'mrs':
                return "Mrs.";
            case 'miss':
            case 'ms':
                return "Ms.";
            case 'dr':
                return "Dr.";
            case 'rev':
                return "Rev.";
            case 'fr':
                return "Fr.";
            default:
                return false;
        }
      }
    };

    //  detect and format common suffixes
    NameParse.is_suffix = function (word) {
      if(word) {
        word = this.removeIgnoredChars(word).toLowerCase();
        // these are some common suffixes - what am I missing?
        var suffixArray = [
            'I','II','III','IV','V','Senior','Junior','Jr','Sr','PhD','APR','RPh','PE','MD','MA','DMD','CME',
            "BVM","CFRE","CLU","CPA","CSC","CSJ","DC","DD","DDS","DO","DVM","EdD","Esq",
            "JD","LLD","OD","OSB","PC","Ret","RGS","RN","RNC","SHCJ","SJ","SNJM","SSMO",
            "USA","USAF","USAFR","USAR","USCG","USMC","USMCR","USN","USNR"
        ];

        var suffixIndex = suffixArray.map(function(suffix){
            return suffix.toLowerCase();
        }).indexOf(word);

        if(suffixIndex >= 0) {
            return suffixArray[suffixIndex]; }
        else {
            return false; }
      }
    };

    // detect compound last names like "Von Fange"
    NameParse.is_compound_lastName = function (word) {
      if(word) {
        word = word.toLowerCase();
        // these are some common prefixes that identify a compound last names - what am I missing?
        var words = ['vere','von','van','de','del','della','di','da','pietro','vanden','du','st.','st','la','lo','ter'];
        return (words.indexOf(word) >= 0);
      }
    };

    // single letter, possibly followed by a period
    NameParse.is_initial = function (word) {
      if(word) {
        word = this.removeIgnoredChars(word);
        return (word.length === 1);
      }
    };

    // detect mixed case words like "McDonald"
    // returns false if the string is all one case
    NameParse.is_camel_case = function (word) {
      if(word) {
        var ucReg = /[A-Z]+/;
        var lcReg = /[a-z]+/;
        return (ucReg.exec(word) && lcReg.exec(word));
      }
    };

    // ucfirst words split by dashes or periods
    // ucfirst all upper/lower strings, but leave camelcase words alone
    NameParse.fix_case = function (word) {
      if(word) {
        // uppercase words split by dashes, like "Kimura-Fay"
        word = this.safe_ucfirst("-",word);
        // uppercase words split by periods, like "J.P."
        word = this.safe_ucfirst(".",word);
        return word;
      }
    };

    // helper for this.fix_case
    // uppercase words split by the seperator (ex. dashes or periods)
    NameParse.safe_ucfirst = function (seperator, word) {
      if(word) {
        return word.split(seperator).map(function(thisWord){
            if(this.is_camel_case(thisWord)) {
                return thisWord;
            } else {
                return thisWord.substr(0,1).toUpperCase() + thisWord.substr(1).toLowerCase();
            }
        }, this).join(seperator);
      }
    };

    return NameParse;
})();

/**
 * baseCoat
 * A front-end framework for Registria
 * version 1.0.0 - 2025
 * Dependencies:
 *   jQuery 3.7.1
 *
 */

var BaseCoat = (function BaseCoat(document, window, $) {

  // Constants
  var $doc = $(document);

/**
 * Internationalization
 *
 * This module is largely automatic. Its methods
 * are used by other modules in the baseCoat framework.
 */

var i18n = (function i18n() {

  /**
   * Returns the value of a particular URL param
   * @param {String} key The key to check
   * @return {String} The value of the param
   */

  var getParam = function getParam(key) {
    var query = window.location.search.substring(1);
    var params = query.split('&');

    return params.reduce(function(output, param) {
      var split = param.split('=');
      if (split[0] === key) return split[1];
      return output;
    }, undefined);
  };

  /**
   * Returns the user's country code
   * based on IP address.
   * @return {String} 2-char ISO country code
   */

  var getCountry = function getCountry() {
    var testCountry = getParam('test_country');
    var isStaging = window.location.href.indexOf('staging') > -1 || window.location.href.indexOf('localhost') > -1;
    if (isStaging && testCountry) return testCountry;
    if ($.IPInfo && $.IPInfo.country_code) return $.IPInfo.country_code;
    return 'US';
  };

  /**
   * Returns the user's locale string or part
   * of the string, optionally.
   * @param {String} part 'language' || 'country' (optional)
   * @return {String} User's current locale
   */

  var getLocale = function getLocale(part) {
    var locale = $.currentLocale || 'en';

    if (typeof part !== 'string') return locale;

    var regex = /([a-z]{2})\-?([a-z]{0,2})/i;
    var matches = locale.match(regex);
    if (matches && matches[0] === locale) matches.shift();

    if (part === 'language') return matches[0];
    if (part === 'country') return matches[1] || null;
    return locale;
  };

  /**
   * Common text translations used in baseCoat.
   * The translation text returned depends on
   * the current user's locale.
   * @param {String} text The option to return
   * @return {String} Translated text
   */

  var translate = function translate(text) {
    var language = getLocale('language');
    var languages = ['fr', 'es', 'en'];
    var translations = {
      close: {
        en: 'Close',
        fr: 'Fermer',
        es: 'Cerrar'
      },

      yesNo: {
        en: ['Yes', 'No'],
        fr: ['Oui', 'Non'],
        es: ['Sí', 'No']
      },

      invalidDate: {
        en: 'Invalid date',
        fr: 'Date invalide',
        es: 'Fecha invalida'
      },

      futureDate: {
        en: 'Can\'t select a future date',
        fr: 'Vous ne pouvez pas sélectionner une date ultérieure',
        es: 'No se puede seleccionar una fecha futura'
      },

      didYouMean: {
        en: 'Did you mean',
        fr: 'Vouliez-vous dire',
        es: '¿Quiso decir'
      },

      intState: {
        en: 'International State',
        fr: 'État international',
        es: 'Estado Internacional'
      },

      postalCode: {
        en: 'Postal Code',
        fr: 'Code Postal',
        es: 'Código Postal'
      },

      postalValidation: {
        en: 'Please enter a valid postal code.',
        fr: 'Saiser un code postal valide s\'il vous plaît.',
        es: 'Por favor, introduzca un código postal válido.'
      },

      fullName: {
        en: 'Please enter your full name.',
        fr: 'S\'il vous plait entrez votre nom entier.',
        es: 'Por favor ingresa tu nombre completo.'
      }
    };

    // Default to English if language is not available.
    if (languages.indexOf(language) < 0) language = 'en';

    return translations[text][language];
  };

  /**
   * Updates various things for
   * Canadian users
   */

  var canadianForm = function canadianForm() {
    var $fields = {
      state: $('#state'),
      zip: $('#zip')
    };

    var rules = {
      state: $fields.state.length ? $fields.state.rules() : {},
      zip: $fields.zip.length ? $fields.zip.rules() : {}
    };

    // Canadian users should get provinces
    if ($fields.state.attr('type') !== 'hidden') {
      $fields.state
        .removeClass('autocomplete-state')
        .addClass('autocomplete-province')
    }

    // Change zip code to postal code
    if ($fields.zip.attr('type') !== 'hidden') {
      $fields.zip = $fields.zip.clone();

      $fields.zip.attr('type', 'text');

      // Add CA validation
      $.validator.addMethod('canadaZip', function(value, elem) {
        if($('#country').val() == "Canada" && $('#zip').val().length == 3) {
          var regex = /^[ABCEGHJKLMNPRSTVWXYZ]\d[ABCEGHJKLMNPRSTVWXYZ](\s\d[ABCEGHJKLMNPRSTVWXYZ]\d)?$/i;
        }
        else {
            var regex = /^([ABCEGHJKLMNPRSTVWXYZ]\s*\d\s*){3}$/i;
        }
        return this.optional(elem) || regex.test(value);
      }, translate('postalValidation'));

      $('#zip').replaceWith($fields.zip);

      $fields.zip = $('#zip');

      $fields.zip.rules('add', 'canadaZip');
      $fields.zip.rules('remove', 'regex');

    }
  };

  /**
   * DOM API
   */

  $(function() {
    var country = getLocale('country') || getCountry();
    var c = country.toUpperCase();
    var $state = $('#state');
    var $zip = $('#zip');
    var locale = $.currentLocale;

    if (c === 'CA' && (locale == 'en-ca' || locale == 'fr-ca' || locale == 'en-fr') && ($state.length || $zip.length)) canadianForm();
  });

  /**
   * Public API
   */

  return {
    getCountry: getCountry,
    getLocale: getLocale,
    translate: translate
  };

})();


/**Get URL Parameter
*/
function GetURLParameter(sParam)
{
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  for (var i = 0; i < sURLVariables.length; i++)
  {
      var sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] == sParam)
      {
          return sParameterName[1];
      }
  }
}

/**
 * Autocomplete
 *
 * baseCoat includes a few standard autocompletes.
 * This module controls them and how they work.
 * View the docs for more information on these.
 */
var autocomplete = (function autocomplete() {

  /**
   * Returns the user's locale string or part
   * of the string, optionally.
   * @param {String} part 'language' || 'country' (optional)
   * @return {String} User's current locale
   */

   var getLocale = function getLocale(part) {
    var locale = $.currentLocale || 'en';

    if (typeof part !== 'string') return locale;

    var regex = /([a-z]{2})\-?([a-z]{0,2})/i;
    var matches = locale.match(regex);
    if (matches && matches[0] === locale) matches.shift();

    if (part === 'language') return matches[0];
    if (part === 'country') return matches[1] || "US";
    return locale;
  };

  /**
   * Throttle execution of a given function
   * @param {Function} fn The function to execute
   * @param {Number} wait Time in ms to wait before executing
   * @param {Boolean} immed When true, execute the function immediately
   */

  var debounce = function debounce(fn, wait, immed) {
    var timeout;
    return function() {
      var ctx = this;
      var args = arguments;
      var later = function() {
        timeout = null;
        if (!immed) fn.apply(ctx, args);
      };

      var callNow = immed && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) fn.apply(ctx, args);
    };
  };
  /**
   * Get a list of products from the platform
   * @param {Function} callback Function to call on success
   * @param {String} category A category name to filter by
   * @param {String} family A family name to filter by
   * @param {Number} limit Max # of items to request
   * @param {Boolean} beginsWith When true, match search with begins_with
   * @param {String} search A substring to search on
   * @param {Array} fields A list of product fields to request
   */

  var getProducts = function getProducts(obj) {
    var callback = obj.callback || function(x){return x};
    var category = obj.category;
    var family = obj.family;
    var brandname = obj.brandname;
    var product_locale = obj.product_locale;
    var product_family_type = obj.product_family_type;
    var limit = obj.limit || 25;
    var beginsWith = obj.beginsWith || false;
    var flexible = obj.flexible || false;
    var term = flexible ? (beginsWith ? 'begins_with_flexible' : 'contains_flexible') : (beginsWith ? 'begins_with' : 'contains');
    var search = obj.search || '';
    search = search.replace(/[\u201C\u201D]/g, '"').replace(/[\u2018\u2019]/g, "'");
    var fields = obj.fields || false;
    var tags = GetURLParameter('productTag');

    var url = '/services/products';
    var params = { limit: limit, alphabetical: true };
    var query = '?';

    // Build params object
    if (category) params.product_category_name = category;
    if (family) params.product_family_name = family;
    if (search) params[term] = search;
    if (fields) params.fields = fields;
    if (brandname) params.brand_name = brandname;
    if (product_locale) params.product_locale = product_locale
    if (tags) params.tags = tags;
    if (product_family_type) params.product_family_type = product_family_type;
    if (obj.active) params.active = obj.active;
    if (obj.allowRegistration) params.allow_registration = obj.allowRegistration;

    // get active and allow_registration fields
    params.fields = params.fields || [];
    params.fields.push('active');
    params.fields.push('allow_registration');

    // create query string
    query += $.param(params);

    // Make the request
    $.ajax({
      type: 'GET',
      url: url + query,
      success: callback,
      error: function(err) {
        console.log(err.responseText, err);
      }
    });
  };

  /**
   * Get a list of organizations from the platform
   * @param {Function} callback Handle the list
   */

  var getOrganizations = function getOrganizations(callback, installers) {
    var fn = callback || function(x) { return x; };
    var params = {};
    var query = '?';
    var url = "/services/organizations";
    var $orgs = $('.autocomplete-organizations');
    if(installers) {
      var $installers = $('.autocomplete-installers');
      params.installers = true;
      params.retailers = false;
      if($installers.attr('data-brandname')) params.brand_name = $installers.attr('data-brandname');
      if($installers.attr('data-locale')) params.country = getLocale('country');
    }else{
      params.installers = false;
      params.retailers = true;
      if($orgs.attr('data-brandname')) params.brand_name = $orgs.attr('data-brandname');
      if($orgs.attr('data-locale')) params.country = getLocale('country');
    }
    params.limit = -1;
    params.show_in_finder = true;
    query += $.param(params);
    // Make the request
    $.ajax({
      type: 'GET',
      url: url + query,
      success: fn,
      error: function(err) {
        console.log(err.responseText, err);
      }
    });
  };

  /**
   * Settings for standard autocompletes
   * @param {String} field Which field to get settings for
   * @return {Object} Settings for the requested field
   */

  var getSettings = function getSettings(field) {
    switch (field) {
      case 'state':
        if ($('html').attr('lang') == 'en-mx') {
          return {
            limit: 5,
            fuzzyMatchBeginsWith: true,
            list: ['Distrito Federal', 'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche', 'Chiapas', 'Chihuahua', 'Coahuila', 'Colima', 'Durango', 'Guanajuato', 'Guerrero', 'Hidalgo', 'Jalisco', 'Michoacán', 'Morelos', 'México', 'Nayarit', 'Nuevo León', 'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora', 'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas']
          };
        }
        return {
          limit: 5,
          fuzzyMatchBeginsWith: true,
          list: ['Alabama', 'Alaska', 'American Samoa', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Puerto Rico', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming', 'Virgin Islands', 'Armed Forces Americas', 'Armed Forces Europe', 'Armed Forces Pacific']
        };
      case 'province':
        return {
          limit: 5,
          fuzzyMatchBeginsWith: true,
          list: ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon']
        };
      case 'product':
        return {
          hiddenField: $('#product')[0],
          limit: Infinity
        };
      default:
        return false;
    }
  };

  /**
   * DOM API
   */

  $(function() {
    // The platform does this, so do it for local testing
    if (window.location.hostname === 'localhost') $('form').validate();

    // Target fields
    var $state = $('.autocomplete-state');
    var $province = $('.autocomplete-province');
    var $product = $('.autocomplete-product');
    var $orgs = $('.autocomplete-organizations');
    var $installers = $('.autocomplete-installers');

    var settings = {};
    var frauto;
    var noAutoCompelete = ["en-au", "en-sg", "en-hk", "en-my", "en-nz", "en-th", "en-ph", "ja-jp", "en-jp","es-bz", "es-bo", "es-ec", "es-sv", "fr-gf", "en-gy", "es-hn", "es-ni", "en-sr", "en-tt"];

    // Simple state and province setup
    if ($state.length && !(noAutoCompelete.includes($('html').attr('lang')))) {
      frautoComplete($state[0], getSettings('state'));
    }
    if ($province.length) frautoComplete($province[0], getSettings('province'));

    // Setup product autocomplete
    if ($product.length) {
      // create frauto
      frauto = frautoComplete($product[0], getSettings('product'));

      // Get settings for list call
      if ($product.attr('data-productcategory')) {
        settings.category = $product.attr('data-productcategory');
      }

      if ($product.attr('data-productfamily')) {
        settings.family = $product.attr('data-productfamily');
      }

      if ($product.attr('data-productfamilytype')) {
        settings.product_family_type = $product.attr('data-productfamilytype');
      }

      if ($product.attr('data-brandname')) {
        settings.brandname = $product.attr('data-brandname');
      }

      if ($product.attr('data-beginswith') === 'true') {
        settings.beginsWith = true;
      }

      if ($product.attr('data-flexible') === 'true') {
        settings.flexible = true;
      }

      if ($product.attr('data-active') === 'true') {
        settings.active = true;
      }

      if ($product.attr('data-allowregistration') === 'true') {
        settings.allowRegistration = true;
      }

      if ($product.attr('data-productlocale')) {
        settings.product_locale = $product.attr('data-productlocale');
      }

      if ($product.attr('data-fields')) {
        settings.fields = JSON.parse($product.attr('data-fields'));
      }

      // set callback
      settings.callback = function(list) {
        frauto.updateList(list.sort(function(a, b) {
          if(a.sku < b.sku) { return -1; }
          if(a.sku > b.sku) { return 1; }
          return 0;
        }));
      };

      // update list on keyup
      $product.on('input', debounce(function() {
        settings.search = $(this).val();
        if (settings.search && settings.search.length > 2) { getProducts(settings); }
      }, 250));
    }
    if ($.siteConfiguration.registration_purchased_at_field.purchased_at_dropdown) {
      $(function() {
        var url = "/services/organizations";
        var params = {};
        var query = '?';
        var $mySelect = $('#purchased-at-drop');
        params.installers = false;
        params.retailers = true;
        if($mySelect.attr('data-brandname')) params.brand_name = $mySelect.attr('data-brandname');
        if($mySelect.attr('data-locale')) params.country = getLocale('country');
        params.limit = -1;
        params.show_in_finder = true;
        query += $.param(params);
          $.ajax({
            url: url + query,
            beforeSend: function(xhr) {
            xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
          },
          dataType: "json",
          success: function(data){
            if(data.length > 0) {
              var $select = $("#purchased-at-drop");
              var selectize = $select[0] && $select[0].selectize;
              var optionList = data;
              if (selectize) {
                // Populate via Selectize API for smooth UX
                selectize.clearOptions();
                optionList.forEach(function(el){
                  selectize.addOption({ value: el.name, text: el.name, id: el.id });
                });
                // Keep empty initial state to show placeholder until user selects
                selectize.refreshOptions(false);
                // Ensure validation rule remains
                if ($.siteConfiguration.registration_purchased_at_field.required) {
                  $('#purchased-at-drop').rules('add', { required: true });
                }
              } else {
                // Fallback: populate native select; Selectize (if initialized later) will pick these up
                $select.empty();
                $.each(optionList, function (i, el) {
                  $select.append($('<option>', {
                    value: el.name,
                    text: el.name,
                    'data-id': el.id
                  }));
                });
                $select.prepend("<option value='' selected='selected'></option>");
                if ($.siteConfiguration.registration_purchased_at_field.required) {
                  $('#purchased-at-drop').rules('add', { required: true });
                }
              }
            } else {
              console.log('no orgs')
            }
          },
          error: function(data) {
            console.log(data);
          }
        });

      });

    } else {
      // Setup orgs autocomplete
      if ($orgs.length) {
        getOrganizations(function(list) {
          var defaultOptions= list.filter(function(org) { return org.doing_business_as.toLowerCase() === "other" || org.label === "Other" });
          frautoComplete($orgs[0], { limit: $orgs.attr('data-limit') || 25, list: list, pinnedItems: defaultOptions, hiddenField: $('#organization')[0] });
        });
      }
    }
    // Setup installers autocomplete
    if($installers.length) {
      getOrganizations(function(list) {
        var defaultOptions= list.filter(function(org) { return org.doing_business_as.toLowerCase() === "other" || org.label === "Self Installed" });
        frautoComplete($installers[0], { limit: $installers.attr('data-limit') || 25, list: list, pinnedItems: defaultOptions, hiddenField: $("#installed_by_id")[0] });
      }, true);
    }
  });

  /**
   * Support old FrautoComplete jQuery plugin
   */

  $.fn.frautoComplete = function(list, settings) {
    if (typeof settings === 'undefined') settings = {}
    return frautoComplete(this[0], {
      list: list || [],
      limit: settings.listLimit || settings.limit,
      validate: settings.validate,
      fuzzyMatchBeginsWith: settings.fuzzyMatchBeginsWith
    });
  };

  /**
   * Public API
   */

  return {
    getProducts: getProducts,
    getOrganizations: getOrganizations,
    getStates: getSettings('state'),
    getProvinces: getSettings('province')
  };

})();

/* Input Masks
 * Dependency jQuery inputmask plugin with V 5.0.2(/vendor_js/inputmask.min.js)
 *
 * baseCoat includes a few standard input
 * masks to restrict and guide input on
 * certain fields. Use the following classes
 * on your fields:
 *
 * .mask-numerical
 *   - Only allows users to type numbers and one period
 *
 * .mask-date
 *   - Custom localized date format mask
 *
 * .mask-mmyy
 *   - Month and year mask (MM/YY or MM/YYYY)
 */

var inputMasks = (function inputMasks() {

    /**
     * Numerical input mask (.mask-numerical)
     * @param {Object} event An event object
     */

    var maskNumerical = function maskNumerical(event) {
      var keyCode = event.which;
      var value = $(event.target).val();

      if (
          // allow .
          (keyCode !== 46 &&

          // allow backspace
          keyCode !== 8 &&

          // allow numbers
          (keyCode < 48 || keyCode > 57)
          ) ||

          // Only allow one .
          (keyCode === 46 && value.indexOf('.') > -1)
        ) {

        // block the key press
        event.preventDefault();
      }
    };

    /**
     * Simple month and year input mask (.mask-mmyy)
     * @param {Boolean} useFullYear When true, mask wants 4-digit year
     */

    var maskMMYY = function maskMMYY(useFullYear) {
      if (useFullYear) {
        return {
          placeholder: 'mm/yyyy',
          mask: 'mm/yy'
        };
      }

      return {
        placeholder: 'mm/yy',
        mask: 'mm/yy'
      };
    };

  /**
   * Localized date format mask (.mask-date)
   */

  var maskDate = (function () {
    const getFormat = function () {
        const country = (i18n.getLocale('country') || 'US').toUpperCase();

        const dateFormats = {
          mdy: ['BZ', 'FM', 'PH', 'US'],
          ymd: ['IR', 'SI', 'ZA', 'SE', 'AF', 'CN', 'HU', 'JP', 'KR', 'KP', 'LT', 'MN', 'TW', 'HK', 'TH']
        };

        let format = {};

        if (dateFormats.mdy.includes(country)) {
          format.inputFormat = 'mm/dd/yyyy';
          format.datepickerFormat = 'mm/dd/yy';
          format.placeholder = 'mm/dd/yyyy';
          format.format = 'mdy';
        } else if (dateFormats.ymd.includes(country)) {
          format.inputFormat = 'yyyy/mm/dd';
          format.datepickerFormat = 'yy/mm/dd';
          format.placeholder = 'yyyy/mm/dd';
          format.format = 'ymd';
        } else {
          format.inputFormat = 'dd/mm/yyyy';
          format.datepickerFormat = 'dd/mm/yy';
          format.placeholder = 'dd/mm/yyyy';
          format.format = 'dmy';
        }

        return format;
      };

    const normalizeDmy = (dateStr) => {
      const [d, m, y] = dateStr.split('/');
      return `${y}/${m}/${d}`;
    };

    /**
     * Parse date string reliably regardless of format
     */
    const parseDate = (dateStr, format) => {
      if (format === 'dmy') {
        const [d, m, y] = dateStr.split('/');
        return new Date(y, m - 1, d);
      } else if (format === 'mdy') {
        const [m, d, y] = dateStr.split('/');
        return new Date(y, m - 1, d);
      } else if (format === 'ymd') {
        const [y, m, d] = dateStr.split('/');
        return new Date(y, m - 1, d);
      }
      return new Date(dateStr); // fallback
    };

    /**
     * Validates the date field and sets a hidden normalized field
     */
    var valiDate = function ($field) {
      var input = $field.val();
      var format = $field.attr('data-format');
      var fieldName = $field.attr('name');
      const $form = $field.closest('form');
      let $hidden = $form.find(`input[type="hidden"][name="${fieldName}"]`);

      if (input === '') {
        $field.addClass('registria_field');
        $hidden.remove();
        return true;
      }

      // Check if input matches the expected format using regex
      let regex;
      if (format === 'dmy') {
        regex = /^\d{2}\/\d{2}\/\d{4}$/;
      } else if (format === 'mdy') {
        regex = /^\d{2}\/\d{2}\/\d{4}$/;
      } else if (format === 'ymd') {
        regex = /^\d{4}\/\d{2}\/\d{2}$/;
      }

      if (!regex.test(input)) {
        $field.addClass('registria_field');
        $hidden.remove();
        return false;
      }

      var isValid = Inputmask.isValid(input, {
        alias: 'datetime',
        inputFormat: $field.attr('placeholder')
      });

      if (!isValid) {
        $field.addClass('registria_field');
        $hidden.remove();
        return false;
      }

      // Use the reliable date parsing function instead of new Date()
      var dateObj = parseDate(input, format);
      if (isNaN(dateObj.getTime())) {
        $field.addClass('registria_field');
        $hidden.remove();
        return false;
      }

      var year = dateObj.getFullYear();
      var month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      var day = ('0' + dateObj.getDate()).slice(-2);
      var normalized = `${year}-${month}-${day}`;

      if ($hidden.length < 1) {
        $field.removeClass('registria_field')
          .after(`<input class="registria_field valid" type="hidden" name="${$field.attr('name')}" value="${normalized}">`);
      } else {
        $hidden.val(normalized);
      }

      return true;
    };

    return {
      format: getFormat,
      normalize: normalizeDmy,
      validate: valiDate,
      parseDate: parseDate // expose for testing if needed
    };
  })();

  $(function () {
    const format = maskDate.format();
    const $maskDate = $('.mask-date');

    $maskDate.each(function () {
      const $input = $(this);
      $input.attr('placeholder', format.placeholder);
      $input.attr('data-format', format.format);

      Inputmask({
        alias: 'datetime',
        inputFormat: format.inputFormat,
        placeholder: format.placeholder,
        clearIncomplete: true,
        showMaskOnFocus: true,
        showMaskOnHover: false
      }).mask($input[0]);

      if ($input.hasClass('datepicker')) {
        let allowReopen = true;
        var isFutureDate = $input.data("allowfuturedates");
        var maxDate = isFutureDate ? "+2y" : new Date();
        var yearRange = isFutureDate ? "-100:+2" : "-100:+0";

        $input.datepicker({
          dateFormat: format.datepickerFormat,
          changeMonth: true,
          changeYear: true,
          maxDate: maxDate,
          yearRange: yearRange,
          beforeShow: function() {
            // Reset the flag when showing the datepicker
            allowReopen = true;
            return {};
          },
          onClose: function() {
            // Validate the date when the picker closes
            maskDate.validate($input);
            // Temporarily prevent reopen for the click event that follows
            allowReopen = false;

          }
        });

        // Handle clicks on the document to manage our flag
        $(document).on('click', function(e) {
          // If click is outside both input and datepicker, allow reopen
          if (!$input.is(e.target) &&
              !$(e.target).closest('.ui-datepicker').length &&
              !$input.datepicker('widget').is(':visible')) {
            allowReopen = true;
          }
        });

      }

      $input.on('blur', function () {
        maskDate.validate($input);
      });
    });

  $.validator.addMethod('realDate', function (value, elem) {
    const placeholder = $(elem).attr('placeholder');
    if (!value || value === placeholder || /[a-zA-Z]/.test(value)) return true;

    return Inputmask.isValid(value, {
      alias: 'datetime',
      inputFormat: placeholder
    });
  }, $.polyglot.t('validations.date'));

  $.validator.addMethod('futureDate', function (value, elem) {
    const $elem = $(elem);
    if (!value) return true;
    if ($elem.is('[data-allowfuturedates]')) return true;

    const format = $elem.attr('data-format');
    const parts = value.split('/');
    if (parts.length !== 3) return false;

    let year, month, day;
    switch (format) {
      case 'mdy': [month, day, year] = parts; break;
      case 'dmy': [day, month, year] = parts; break;
      case 'ymd': [year, month, day] = parts; break;
      default: return false;
    }

    year = parseInt(year, 10);
    month = parseInt(month, 10) - 1;
    day = parseInt(day, 10);

    if (isNaN(year) || isNaN(month) || isNaN(day)) return false;

    const inputDate = new Date(year, month, day);
    const today = new Date();
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return inputDate <= today;
  }, $.polyglot.t('validations.date'));

  $.validator.addClassRules('mask-date', {
    realDate: true,
    futureDate: true
  });
});


})();


/**
 * Properly sets the value on the a given checkbox element
 * @param {jQuery Element} $field The field to toggle
 */

var toggleCheckbox = function toggleCheckbox(event) {
  var $field = $(event.target);
  var val = $field.val();
  var noUpdate = val !== '' && val !== '0' && val !== '1' && val !== 'on';
  var name = $field.attr('name');
  var $hidden = $('<input type="hidden" name="'+ name +'" class="real_checkbox registria_field" />');
  var optout = $field.is('[data-optout]');
  var newVal;

  /**
   * If the field has a pre-set value,
   * don't do anything to the value.
   */

  if (noUpdate) return;

  /**
   * Initialize hidden field
   */

  if ($field.siblings('[type="hidden"].real_checkbox').length < 1) {
    $field.after($hidden);
    $field.removeClass('registria_field');
  }

  $hidden = $field.siblings('[type="hidden"].real_checkbox');

  /**
   * Update the value
   */

  if ($field.is(':checked')) {
    newVal = optout ? '0' : '1';
  } else {
    newVal = optout ? '1' : '0';
  }

  $hidden.val(newVal);
};

$(function() {
  $('input[type="checkbox"]').each(function(){
    toggleCheckbox({ target: this });
  })
  $('input[type="checkbox"]').on('change', toggleCheckbox);
});
/**
 * @param {string} text
 * @return {string}
 */
 function sanitizeHTML(text) {
  return $('<div>').text(text).html();
}
(function() {

  var selector = '.dropdown-toggle';

  function init($nodes) {
    var newNodes = [];

    $nodes.each(function() {
      var $this = $(this).removeClass(selector.replace('.', ''));
      var $options = $this.find('option');

      var $current = $options.filter('[selected]');
      var $selected = $current.length ? $current : $options.first();

      var target = $this.data('target');
      var classes = Array.prototype.slice.call($this[0].classList);
      var id = $this.attr('id');

      var $nav = $('<nav class="dropdown-toggle" />')
        .data('target', target)
        .append('<span class="current" />')
        .append('<ul class="options" style="display:none" />');


      if (id) $nav.attr('id', id);
      $nav.addClass(classes.join(' '));
      $nav.find('.current').text($current.text());

      $options.each(function() {
        var $this = $(this);
        var text = sanitizeHTML($this.text());
        var value = sanitizeHTML($this.val());

        $nav.find('.options')
          .append('<li data-value="' + value + '">' + text + '</li>');

        if ($this[0] === $selected[0]) {
          if (target && target !== 'url') {
            $(target).val(value);
          }

          $nav.find('.options > li:last-child').css('display', 'none');
        }
      });

      $this.replaceWith($nav);
    });
  }

  function toggleOpen($dropdown) {
    $dropdown.find('.current').toggleClass('open');
    $dropdown.find('.options').slideToggle(250);
  }

  function onSelection(event) {
    var $event = $(event.target);
    var $dropdown = $event.parents(selector);
    var target = $dropdown.data('target');
    var value = $event.data('value');

    if (!target || target === 'url') {
      window.location = value;
    } else {
      $(target).val(value).trigger('change');
    }

    $dropdown.find('.current').text($event.text());
    toggleOpen($dropdown);
    $dropdown.find('.options > li').show();
    $event.hide();
  }

  $(function() {
    init($(selector));
    var $elem = $(selector);

    $elem.on('click', '.current', function() {
      toggleOpen($(this).parents(selector));
    });

    $elem.on('click', '.options > li', onSelection);
  });

})();

/**
 * Show filename in custom file input
 */

var customFileInput = function customFileInput() {
  var $this = $(this);
  var $label = $this.parent('label').find('.file-label');
  var filepath = $this.val();
  var filename = filepath.match(/[^\/\\]*$/)[0];

  // Save the original label text in data-text
  if (!$label.is('[data-text]')) {
    $label.attr('data-text', $label.text());
  }

  // Recall the original text if no file is selected
  if (!filename) filename = $label.attr('data-text');

  // Update the label text
  $label.text(filename);
};

$(function() {
  $('label.file-input').on('change', 'input[type="file"]', customFileInput);
});

/**
 * Hide Toggle
 *
 * Allows implementers to toggle the
 * display of DOM elements using a set
 * of data attributes.
 *
 * [data-toggles]
 *   String, the selector to toggle
 * [data-toggle-show]
 *   Boolean, when true show the target
 *   element initially. When applied to
 *   checkboxes or radio buttons, :checked
 *   value determines target initial display.
 */

var hideToggle = (function hideToggle() {
  /**
   * Class name to apply to an
   * element to hide it.
   */

  var hiddenClass = 'hidden-text';

  /**
   * Toggle
   *
   * Creates a Toggle object given
   * some settings.
   *
   * @param {Object} settings Set toggler, target, and type
   */

  function Toggle(settings) {
    return {
      toggler: $(settings.toggler),
      target: $(settings.target)
    };
  }

  /**
   * clearFields
   *
   * Clears the value of any fields
   * inside a given DOM element.
   *
   * @param {jQuery Object} $target Clear this element's child fields
   */

  function clearFields($target) {
    $target.find('[type="radio"], [type="checkbox"]')
      .removeAttr('checked');

    $target.find('select > option')
      .removeAttr('selected');

    $target.find(':input').not(':button, :submit, :reset, [type="radio"], [type="checkbox"]')
      .val('');
  }

  /**
   * trigger
   *
   * Triggers show/hide display for
   * data-toggle-show given a Toggle object.
   *
   * @param {Object} toggle The Toggle to trigger
   */

  function trigger(toggle) {
    var targetID = toggle.toggler.data('toggles');
    var $target = $(toggle.target);

    var $togglers = $('[data-toggles="' + targetID + '"]');
    var $show = $togglers.filter('[data-toggle-show="true"]');
    var $hide = $togglers.filter('[data-toggle-show="false"]');
    var notChecked = (!$show.is(':checked') && !$hide.is(':checked'));
    var hideTarget = notChecked || $hide.is(':checked');

    if ($togglers.length === 1) {
      $target.toggleClass(hiddenClass);
    } else {
      $target.toggleClass(hiddenClass, hideTarget);
    }

    if ($target.hasClass(hiddenClass)) clearFields($target);
  }

  /**
   * toggleEvent
   *
   * Handles click and change events
   * on [data-toggles]
   *
   * @param {Object} event The DOM event
   */

  function toggleEvent(event) {
    var $event = $(event.target);

    var toggle = Toggle({
      toggler: $event,
      target: $event.data('toggles')
    });

    if (toggle && toggle.target.length) trigger(toggle);
  }

  return toggleEvent;
})();

$(function() {
  $('[data-toggles]')
    .on('click change', hideToggle)
    .each(function() {
      hideToggle({ target: this });
    });
});

/**
 * Suggest a correction when users
 * typo common email domains.
 */

var mailcheck = function mailcheck($field) {
  var $label = $field.parents('label');

  // Generate an HTML string given the email suggestion
  var template = function template(suggestion) {
    return '<p class="form-helper-text update-email">' +
      i18n.translate('didYouMean') +
      ' <a href="#" class="email-link">' +
        suggestion.full +
      '</a>?' +
    '</p>';
  };

  // Do the thing.
  $field.mailcheck({
    suggested: function(elem, sugg) {
      if ($label.find('.update-email').length === 0) {
        $field.after(template(sugg));
      } else {
        $label.find('.update-email').remove();
        $field.after(template(sugg));
      }

      $label.on('click', '.update-email', function(event) {
        if (event) event.preventDefault();
        if (sugg && sugg.full) $field.val(sugg.full);
        $field.valid();
        $label.find('.update-email').remove();
      });
    },

    empty: function() {
      $label.find('.update-email').remove();
    }
  });
};

$(function() {
  $('input[type="email"]').on('blur', function() {
    mailcheck($(this));
  });
});

/**
 * Parse full name field into its
 * parts and populate fields.
 */

var nameParse = function nameParse($field) {
  /**
   * Create or update a given field
   * depending on whether it already exists.
   * @param {jQuery Element} $f The field to check
   * @param {String} value The value to pass to the field
   */

  var createOrUpdate = function createOrUpdate($f, value) {
    var name = $f.attr('name');
    var $domField = $('[name="' + name + '"]');

    // skip if name is blank
    if (!name) return false;

    // update the value of fake field
    if (value) $f.val(value);

    // Update if field exists
    if ($domField.length) {
      $domField.val(value);
    } else {
      // Otherwise, append
      if (value) $field.after($f);
    }

    // Remove the field if no value for it
    if (!value) $domField.remove();
  };

  /**
   * Create and populate hidden fields
   * @param {Object} parsed NameParse object
   */

  var populateFields = function populateFields(parsed, target) {
    var obj = target || 'user';
    var fields = {
      user: 'user',
      shipping: 'order[shipping_address_attributes]',
      billing: 'order[biling_address_attributes]',
      'case': 'case'
    };

    var $f = $('<input type="hidden" class="registria_field">');
    var $prefix = $f.clone().attr('name', fields[obj] + '[title]');
    var $first = $f.clone().attr('name', fields[obj] + '[first_name]');
    var $middle = $f.clone().attr('name', fields[obj] + '[middle_name]');
    var $last = $f.clone().attr('name', fields[obj] + '[last_name]');

    if (obj === 'user') createOrUpdate($prefix, parsed.salutation);
    if (obj === 'user') createOrUpdate($middle, parsed.initials);
    createOrUpdate($first, parsed.firstName);
    createOrUpdate($last, parsed.lastName);
  };

  var value = $field.val();
  var target = $field.data('target');

  // If value is 1 char, NameParse will ignore it
  if (value.length === 1) {
    return populateFields({ firstName: value.toUpperCase() }, target);
  }

  populateFields(NameParse.parse(value), target);
};

$(function() {
  var $fullName = $('.full-name');

  // split on blur
  $fullName.on('blur change', function() {
    var $this = $(this);
    var $label = $this.parents('label');

    nameParse($this);
  });

  // validate if required
  $.validator.addMethod('fullName', function(value, elem) {
    if (value.length < 1) return true;
    if (value.length === 1) return false;

    var parsed = NameParse.parse(value);
    var hasLastName = (parsed.lastName.length > 0);

    return this.optional(elem) || hasLastName;
  }, i18n.translate('fullName'));

  $.validator.addClassRules('full-name', {
    fullName: true
  });
});

/**
 * Prefill fields by passing their ID as
 * a query param key with the value being
 * what you want to prefill the field with.
 */

$(function() {
  (function fieldPrefills() {
    /**
     * Returns an object of URL params
     * @return {Object} URL params
     */

    var getParams = function getParams() {
      var query = window.location.search.substring(1);
      var params = query.split('&');

      return params.map(function(param) {
        var split = param.split('=');
        return { key: split[0], value: decodeURIComponent(split[1]) };
      });
    };

    /**
     * Populate a field given a corresponding
     * param key
     * @param {String} param The param key
     */

    var popField = function popField(param) {
      if (param) {
        if(param.key) {
          $('#' + param.key).val(param.value);
        }
      }
    };

    getParams().forEach(function(param) {
      popField(param);
    });
  })();
});

/**
 * Select
 *
 * Creates custom components for select
 * elements. Can be disabled for a given
 * field by adding the class name default.
 */

var select = (function select() {
  /**
   * setupMulti
   *
   * Converts a given select[multiple]
   * field into the custom component.
   *
   * @param {jQuery Element} $field The field to transform
   */

  function setupMulti($field) {
    var $container = $('<ul class="multi-select" />');
    var $options = $field.find('option');

    $options.each(function() {
      var $opt = $(this);
      var value = sanitizeHTML($opt.val());
      var text = sanitizeHTML($opt.text());
      var selected = $opt.is(':selected');
      var $node = $('<li class="multi-option" tabindex="0" />').clone();

      $node.text(text).attr('data-value', value);
      if (selected) $node.addClass('selected');
      $container.append($node);
    });

    $field.after($container);
  }

  /**
   * selectMulti
   *
   * Handles events on multiselect options.
   *
   * @param {Object} event The event payload
   */

  function selectMulti(event) {
    var $event = $(event.target);
    var $hidden = $event.parents('label').find('select');

    var values = $hidden.val() || [];
    var value = $event.data('value');
    var index = values.indexOf(value);
    var max = $hidden.data('max');
    var selected = $event.parents('label').find('.multi-option.selected').length;

    var type = event.type;
    var keycode = event.which;

    // only listen for spacebar to toggle
    if (type === 'keypress' && keycode !== 32) return;

    // don't allow more selections than max
    if (max && selected >= max && !$event.hasClass('selected')) return;

    $event.toggleClass('selected');

    // if item is in values, remove it
    if (index > -1) {
      values.splice(index, 1);
    } else {
      // otherwise, add it
      values.push(value);
    }

    // update the real field
    $hidden.val(values);
  }

  return {
    multi: {
      init: setupMulti,
      event: selectMulti
    }
  };
})();

$(function() {
  $('select[multiple]:not(.default)').each(function() {
    select.multi.init($(this));
  });

  $('label').on('click keypress', '.multi-option', select.multi.event);

  $('.expand-button-help').on('click', function(){
    $(".icon", this).toggleClass('fa-question-circle fa-angle-up');
  });
  $('.expand-button-inline').on('click', function(){
    $(".icon", this).toggleClass('fa-angle-down fa-angle-up');
  });

  $('.btn-expand-section').on('click', function(){
    $(".question-expand", this).toggleClass('fa-question-circle fa-angle-up');
    $(".info-expand", this).toggleClass('fa-info-circle fa-angle-up');
    $(".angle-expand", this).toggleClass('fa-angle-down fa-angle-up');
  });

  $('input[type="file"]').on('change', function() {
    var file_path = $(this).val();
    var file_name = file_path.match(/[^\/\\]*$/)[0];
    $(this).siblings('.upload-text').html(file_name);
  });

  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    // Do Nothing
  }else
  {
    $('.select-multiple').select2({
      closeOnSelect: false
    });
  }
});

/* Phone Number mask and validation
  dependency intlTelInput 18.2.1 ( vendor_js/intlTelInput.js )
  validation message under translations tag: validations.required_phone
*/

$(function() {
  var $phone = $(".mask-phone");
  if ($phone.length) {
    var fieldName = $('.mask-phone').attr('name');
    $('.mask-phone').after('<input type=hidden id="phone-hidden"  name="' + fieldName + '" class="registria_field" />');
    $('#phone-hidden').val($phone.val().trim());
    //var phone_field = $(":input[name*='user[phone]']");
    var isRequired = $phone.attr("required")?true:false ;
    if ( _.get($.siteConfiguration,"user_phone_field.display" )){
      const $errorMsg = $("#error-msg");
      const $validMsg = $("#valid-msg");
      if($phone.length > 0) {
      // const confLocales = $.siteConfiguration.locales;
      var confLocale = $.currentLocale;
      var uniqueValue = [];
       if( confLocale == "en")
       {
        uniqueValue.push("us");
       } else {
        uniqueValue.push(confLocale.split('-')[1]);
       }
      var euLocales = ['gb', 'fr', 'de', 'it', 'es'];
      var nationalMode = !euLocales.includes(uniqueValue[0]);
       // console.log(uniqueValue);
      const iti = window.intlTelInput($phone[0], {
        defaultCountry: 'us',
        onlyCountries: uniqueValue,
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.2.1/js/utils.js",
        allowDropdown: false,
        formatOnDisplay: true,
        separateDialCode: true,
        autoPlaceholder: "aggressive",
        customPlaceholder: function(placeholder, selectedCountryData) {
          return placeholder.replace(/\d/g, "X");  // Mask with X's
        },
        ...(nationalMode === false ? { nationalMode: false } : {})
      });
      $.validator.addMethod("intlTelNumber", function(value, element) {
                return this.optional(element) || iti.isValidNumber();
            }, $.polyglot.t('validations.phone_number_invalid'));
      $phone.rules('add', {
        intlTelNumber: true,
        messages: {
          intlTelNumber: $.polyglot.t('validations.phone_number_invalid')
        }
      });
      function validatePhoneNumber() {
        const phoneNumber = $phone.val().trim();
        const countryData = iti.getSelectedCountryData();
        var errorElement = $('#phone-error');
       /*  if(errorElement.length === 0){
          $('.mask-phone').after('<span  id="phone-error" class="invalid" />');
          errorElement = $('#phone-error');
        } */
        if (!phoneNumber) {
          $phone.removeClass('valid');
          if(errorElement.length === 1){
             if($phone.attr('required')){
              errorElement.text($.polyglot.t('validations.required'));
            } else {
              errorElement.hide();
            }
          }
          return false;
        }

        if (iti.isValidNumber()) {
          $phone.removeClass('invalid').addClass('valid');
          if ($('#phone-hidden').length === 0) {
            var fieldName = $('.mask-phone').attr('name');
            $('.mask-phone').after('<input type=hidden id="phone-hidden"  name="' + fieldName + '" class="registria_field" />');
          }
           $('#phone-hidden').val(iti.getNumber());
          // console.log("full number", iti.getNumber());
          const isShippingField = $phone.attr('id') === 'shipping_phone';
          if(isShippingField) {
            if ($('#phone-hidden-shipping').length === 0) {
            $('.mask-phone').after('<input type=hidden id="phone-hidden-shipping"  />');
          }
           $('#phone-hidden-shipping').val(iti.getNumber());
          }
          errorElement.hide();
          return true;
        } else {
          $phone.removeClass('valid').addClass('invalid');
          errorElement.show();
          return false;
        }
      }
       $phone.on('change blur', function() {
          validatePhoneNumber();
       });
       $phone.on('input', function(e) {
          const fullNumber = iti.getNumber();
          const countryCode = iti.getSelectedCountryData().dialCode;

          if (fullNumber.startsWith(`+${countryCode}`)) {
            $('#phone-hidden').val(fullNumber);
            const isShippingField = $phone.attr('id') === 'shipping_phone';
            if(isShippingField) {
              $('#phone-hidden-shipping').val(fullNumber);
            }
            iti.setNumber(fullNumber);
            sessionStorage.setItem('phoneNumber', fullNumber);
          }
        });
        $(document).ready(function() {
          const storedPhoneNumber = sessionStorage.getItem('phoneNumber');
            if (storedPhoneNumber) {
              // Prepopulate the phone input with the stored number (including country code)
              if(storedPhoneNumber.indexOf($('.iti__selected-dial-code').text()) == 0 ){
                iti.setNumber(storedPhoneNumber);
                if ($('#phone-hidden').length === 0) {
                  var fieldName = $('.mask-phone').attr('name');
                  $('.mask-phone').after('<input type=hidden id="phone-hidden"  name="' + fieldName + '" class="registria_field" />');
                }
                $('#phone-hidden').val(storedPhoneNumber);
                $('#phone-hidden-shipping').val(storedPhoneNumber);

              }

            } else{
              var phoneValue = $('.mask-phone').val().trim();
              // Check if the value doesn't start with '+'
              if (phoneValue && !phoneValue.startsWith('+')) {
               if( $.currentLocale === 'en' || $.currentLocale.toLowerCase() === 'en-us' || $.currentLocale.toLowerCase().endsWith('-ca')){
                phoneValue = '+1' + phoneValue;
                iti.setNumber(phoneValue);
                $('#phone-hidden').val(phoneValue);
                $('#phone-hidden-shipping').val(phoneValue);
                }

              }

            }
            var referenceWidth = $('.iti__flag-container').width();
            referenceWidth = referenceWidth > 30 ? referenceWidth + 10 : 40 + 10;
            $('.mask-phone')[0].style.setProperty('padding-left', referenceWidth + 'px', 'important');
            if ($('.mask-phone').is(':visible') && $phone.val().trim() ) {
              if ($('#phone-hidden').length === 0) {
                var fieldName = $('.mask-phone').attr('name');
                $('.mask-phone').after('<input type=hidden id="phone-hidden"  name="' + fieldName + '" class="registria_field" />');
                $('#phone-hidden').val($phone.val().trim());
                $phone.trigger('input');
              }
            }
        });
        // Get full Phone Number on form submit
        $('#registria_form').on('submit', function (event) {
          validatePhoneNumber()
          if ($('#registria_form').valid() && $phone.valid()) {
            var hidden = $('#phone-hidden').val();
            if (!hidden || hidden.length === 0) {
              $phone.val(iti.getNumber());
            }
          }
        });

      }

    }
  }
  });
  // end of phone field Validation

/**
 * Public Methods
 */

return {
  i18n: i18n,
  // modal: modal,
  // geolocation: geolocation,
  autocomplete: autocomplete
};

})(document, window, jQuery);

/* Locale Javascript Code */
window.addEventListener('DOMContentLoaded', function () {
  $('.language-select .langauge').each(function () {
    var newUrl =  $(this).attr('href') + window.location.search;
   // console.log("newUrl = " + newUrl + "window.location serach = " + window.location.search);
    $(this).attr('href', newUrl);
    // console.log("this attr href value = " + $(this).attr('href', newUrl));
  });
});

$(document).ready(function($){
  $('.close-search').on('click', function(){
    $(".search-menu").removeClass('dropdown-menu-open');
  });

  $(".nav-dropdown").off("click").on('click', function (e) {
    
    if( $(this).parent(".dropdown").hasClass("dropdown-open") ){
      $(this).parent(".dropdown").removeClass("dropdown-open");
      $(this).siblings(".dropdown-menu").removeClass("dropdown-menu-open");

    } else {
    e.stopPropagation();
    $(this).parent(".dropdown").addClass('dropdown-open');
    $(this).siblings(".dropdown-menu").addClass('dropdown-menu-open');
    }
    $('.dropdown-menu-open').on('click', function(e) {
        e.stopPropagation();
    });
  });

  $('body').on('click', function(){
    if( $(".dropdown").hasClass("dropdown-open") ){
      $(".dropdown").removeClass("dropdown-open");
      $(".dropdown-menu").removeClass("dropdown-menu-open");
    };
  });
});
$(document).ready(function(){
	if($.cookie("header") == "custom"){
		$('body').addClass("header-mast-hidden");
	    $('body').addClass("custom-header");}
});
var converter = new showdown.Converter();

var renderMarkdown = function(element, markdown) {
  if ( element.length && _.trim(markdown).length > 0 ) {
    $('.markdown-body', element).html(getMarkdown(markdown));
  }
}

var getMarkdown = function(markdown) {
  return converter.makeHtml(markdown);
}

$(window).on("load", function () {
  $(document.links).filter(function () {
      return this.hostname !== window.location.hostname && !this.classList.contains('skip-blank');
  }).each(function () {
      $(this).attr({
        target: "_blank",
        rel: "noopener noreferrer",
      });
    
    let $link = $(this);
    let hasLabel = $link.attr("aria-label");
    let hasHiddenSpan = $link.find(".sr-only, .visually-hidden").length > 0;

    let $clone = $link.clone();
    $clone.find('.sr-only, .visually-hidden').remove();

    let visibleText = '';

    $clone.contents().each(function () {
      let text = '';
      if (this.nodeType === 3) {
        text = this.nodeValue.trim();
      } else if (this.nodeType === 1) {
        text = $(this).find("*").addBack().contents().map(function () {
          return this.nodeType === 3 ? this.nodeValue.trim() : '';
        }).get().join(' ');
      }
      visibleText += text + ' ';
    });

    visibleText = visibleText.replace(/\s+/g, ' ').trim();

    if (visibleText.length > 0 && !hasLabel) {
      $link.attr("aria-label", visibleText + " (opens in a new tab)");
    }

    if (!hasHiddenSpan) {
      $link.append('<span class="sr-only"> (opens in a new tab)</span>');
    }
  });
});
function setReferrerCookie(default_value) {
  if ($.cookie('ref_url') !== undefined && _.includes($.cookie('ref_url'), $.siteConfiguration.enable_esp.direct_mail_referrer)) { return true; }

  if (typeof default_value !== 'undefined' && !(_.includes(document.location.href, '&r=') || _.includes(document.location.href, '&referrer=') || _.includes(document.location.href, '&refer='))) {
    $.cookie('ref_url', default_value, { secure: true, path: '/' });
  }

  if (_.includes(document.location.href, '&r=')) {
    $.cookie('ref_url', getUrlParameter('r'), { secure: true, path: '/' });
  }

  if (_.includes(document.location.href, '&referrer=')) {
    $.cookie('ref_url', getUrlParameter('referrer'), { secure: true, path: '/' });
  }

  if (_.includes(document.location.href, '&refer=')) {
    $.cookie('ref_url', getUrlParameter('refer'), { secure: true, path: '/' });
  }
}

function getEventJourney() {
  return $.currentFlow === 'reverse_registration' ? 'reverse_offer' : 'registration';
}
